export const TABS = Object.freeze({
  HOME: 'home',
  OPEN_TICKET: 'open-ticket',
  MY_CASES: 'my-cases',
  REDEEM_CODE: 'redeem-code',
  ACTIVITIES: 'activities',
  MOBILE: 'mobile',
  ADMIN_FORM: 'admin-form',
  OFFLINE_FORM: 'offline-form',
});
export const LOCALES = new Map([
  ['de', 'de-DE'],
  ['en', 'en-US'],
  ['es', 'es-ES'],
  ['fr', 'fr-FR'],
  ['it', 'it-IT'],
  ['ja', 'ja-JP'],
  ['ko', 'ko-KO'],
  ['nl', 'nl-NL'],
  ['pt-BR', 'pt-BR'],
  ['sv', 'sv-SE'],
  ['zh-Hans', 'zh-HANS'],
  ['zh-Hant', 'zh-HANt'],
]);

export const MILO_LOCALES = new Map([
  ['de', 'de_DE'],
  ['en', 'en_US'],
  ['es', 'es_ES'],
  ['fr', 'fr_FR'],
  ['it', 'it_IT'],
  ['ja', 'ja_JP'],
  ['ko', 'ko_KR'],
  ['nl', 'nl_NL'],
  ['pt-BR', 'pt_BR'],
  ['pt-br', 'pt_BR'],
  ['sv', 'sv_SE'],
  ['zh-Hans', 'zh_CN'],
  ['zh-Hant', 'zh_TW'],
  ['zh-hans', 'zh_CN'],
  ['zh-hant', 'zh_TW'],
]);

export const COVEO_LANG_MAPPING = {
  'zh-Hans': 'zh-cn',
  'zh-Hant': 'zh-tw',
  nl: 'nl',
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  'pt-BR': 'pt-br',
  es: 'es-es',
  sv: 'sv',
};

const STATUS_MESSAGE_PAGE_LANG_ALIASES = {
  'es-ES': 'es',
  es_ES: 'es',
  'zh-CN': 'zh-Hans',
  zh_CN: 'zh-Hans',
  'zh-HANS': 'zh-Hans',
  'zh-hans': 'zh-Hans',
  zh_Hans: 'zh-Hans',
  'zh-TW': 'zh-Hant',
  zh_TW: 'zh-Hant',
  'zh-HANT': 'zh-Hant',
  'zh-hant': 'zh-Hant',
  zh_Hant: 'zh-Hant',
  pt_BR: 'pt-BR',
};

/** Maps page lang (incl. BCP47 variants) to status message API locale segment. */
export function resolveStatusMessageLocale(pageLang) {
  const normalized =
    STATUS_MESSAGE_PAGE_LANG_ALIASES[pageLang] ||
    STATUS_MESSAGE_PAGE_LANG_ALIASES[pageLang?.trim?.()] ||
    pageLang;
  return COVEO_LANG_MAPPING[normalized] || COVEO_LANG_MAPPING.en;
}

export const HELPX_LANG_MAPPING = {
  'zh-Hans': 'cn',
  'zh-Hant': 'tw',
  nl: 'nl',
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  ja: 'jp',
  ko: 'kr',
  'pt-BR': 'pt',
  es: 'es',
  sv: 'se',
};

export const EXL_LANG_MAPPING = {
  'zh-hans': 'zh-hans',
  'zh-hant': 'zh-hant',
  nl: 'nl',
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  'pt-br': 'pt-br',
  es: 'es',
  sv: 'se',
};

export const COMMUNITY_LANG_MAPPING = {
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  nl: 'nl',
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  'pt-BR': 'pt',
  es: 'es',
  sv: 'se',
};

export const IMAGE_ALLOWED = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

export const OPEN_STATUS_WORKFRONT = [
  'Awaiting Customer Feedback',
  'Awaiting Owner',
  'Awaiting Partner Feedback',
  'Awaiting Requester',
  'Awaiting Workfront Feedback',
  'Escalated',
  'Meeting Pending',
  'New',
  'Open',
  'Identified',
  'Monitoring',
  'Investigating',
  'Pending Release',
];

export const MILO_CASE_CREATE_OBJECT = {
  title: '',
  contactRengaId: '',
  orgId: '',
  description: '',
  priorityCode: '',
  language: '',
  productCode: '',
  channelCode: 3,
  typeCode: 2,
  impactCode: '',
  email: '',
  ccEmailList: [],
  timezone: '',
  phone: '',
  optInCountryCode: '',
  smsOptIn: false,
  whatsappOptIn: false,
  productMetadata: null,
  issueReasonCode: '',
};
// URLs starting with http://, https://, or ftp://
export const URL_PATTERN_HTTP = /(\B(HTTPS?|FTP):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;

// URLs starting with "www." (without // before it).
export const URL_PATTERN_WWW = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

// Change email addresses to mailto:: links.
export const EMAIL_PATTERN =
  /([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$)/gim;

export const PHONE_NUMBER_REGEX = new RegExp(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{2,4})[-. )]*(\d{2,4})[-. ]*(\d{4,5})(?: *x(\d+))?\s*$/);

/**
 * Feature flag: country-code phone field + SMS/WhatsApp opt-in (Alert Service eligibility).
 * Set `VITE_ENABLE_PHONE_NOTIFICATION_OPT_IN=true` to enable; any other value keeps the legacy single phone field.
 */
export const ENABLE_PHONE_NOTIFICATION_OPT_IN =
  (import.meta.env.VITE_ENABLE_PHONE_NOTIFICATION_OPT_IN || '').toLowerCase() === 'true';

export const ESCALATE_CASE_REASON_CODES = [
  { id: 5, label: 'Agent Communication Skills' },
  { id: 6, label: 'Agent Technical Knowledge' },
  { id: 3, label: 'Awaiting Callback/Update' },
  { id: 1, label: 'Change in Issue Urgency' },
  { id: 4, label: 'Resolution did not meet expectations' },
  { id: 2, label: 'Time to Resolution' },
];

export const REOPEN_CASE_REASON_CODES = [
  { id: 3, label: 'Resolution did not solve issue' },
  { id: 1, label: 'Resolution partially solved issue' },
  { id: 2, label: 'Issue has reoccurred' },
];

export const AFFECTED_URL_REGEX = new RegExp(/^(http|https):\/\/[a-z0-9]+([\-\.][a-z0-9]+)*/);

export const PROJECT_URL_REGEX = new RegExp(
  /^(https?):\/\/(?:[a-z0-9]+(?:[\-\.](?:[a-z0-9]{1,2}|(west|east)europe[\-][a-z0-9]{1,2})))\.magento\.cloud\/projects\/([a-z0-9]{2,15})|(https?):\/\/console\.adobecommerce\.com\/[a-z0-9\-]+\/([a-z0-9]{2,20})|(https?):\/\/demo\.magento\.cloud/,
);
export const CLOSE_CASE_REASON_CODES = [
  { id: 2, label: 'Issue Obsolete or No Longer Occurs' },
  { id: 1, label: 'Resolution Confirmed' },
  { id: 3, label: 'Resolution Irrelevant or No Longer Requires a Resolution' },
];

export const TIMEZONEOPTIONS = [
  {
    label: '(UTC-12:00) International Date Line West',
    value: 0,
    UTC_OFFSET: -720,
    abbreviation: 'IDLW',
  },
  {
    label: '(UTC-11:00) Coordinated Universal Time-11',
    value: 6,
    UTC_OFFSET: -660,
    abbreviation: 'UTC-11',
  },
  {
    label: '(UTC-10:00) Hawaii',
    value: 2,
    UTC_OFFSET: -600,
    abbreviation: 'HST',
  },
  {
    label: '(UTC-10:00) Aleutian Islands',
    value: 7,
    UTC_OFFSET: -600,
    abbreviation: 'HDT',
  },
  {
    label: '(UTC-9:00) Marquesas Islands',
    value: 8,
    UTC_OFFSET: -570,
    abbreviation: 'MART',
  },
  {
    label: '(UTC-9:00) Coordinated Universal Time-09',
    value: 9,
    UTC_OFFSET: -540,
    abbreviation: 'AKST',
  },
  {
    label: '(UTC-9:00) Alaska',
    value: 3,
    UTC_OFFSET: -540,
    abbreviation: 'AKST',
  },
  {
    label: '(UTC-8:00) Coordinated Universal Time-08',
    value: 11,
    UTC_OFFSET: -480,
    abbreviation: 'PST',
  },
  {
    label: '(UTC-8:00) Baja California',
    value: 5,
    UTC_OFFSET: -480,
    abbreviation: 'PST',
  },
  { label: '(UTC-8:00) Pacific Time (US & Canada)', value: 4, UTC_OFFSET: -480, abbreviation: 'PST' },
  {
    label: '(UTC-7:00) Arizona',
    value: 15,
    UTC_OFFSET: -420,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-7:00) Chihuahua, La Paz, Mazatlan',
    value: 12,
    UTC_OFFSET: -420,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-7:00) Mountain Time (US & Canada)',
    value: 10,
    UTC_OFFSET: -420,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-6:00) Easter Island',
    value: 34,
    UTC_OFFSET: -360,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-6:00) Guadalajara, Mexico City, Monterrey',
    value: 29,
    UTC_OFFSET: -360,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-6:00) Central Time (US & Canada)',
    value: 20,
    UTC_OFFSET: -360,
    abbreviation: 'MST',
  },
  { label: '(UTC-6:00) Central America', value: 33, UTC_OFFSET: -360, abbreviation: 'MST' },
  {
    label: '(UTC-6:00) Saskatchewan',
    value: 25,
    UTC_OFFSET: -360,
    abbreviation: 'MST',
  },
  {
    label: '(UTC-5:00) Indiana (East)',
    value: 40,
    UTC_OFFSET: -300,
    abbreviation: 'ACT',
  },
  {
    label: '(UTC-5:00) Bogota, Lima, Quito, Rio Branco',
    value: 45,
    UTC_OFFSET: -300,
    abbreviation: 'ACT',
  },
  { label: '(UTC-5:00) Haiti', value: 43, UTC_OFFSET: -300, abbreviation: '' },
  {
    label: '(UTC-5:00) Chetumal',
    value: 301,
    UTC_OFFSET: -300,
    abbreviation: 'ACT',
  },
  { label: '(UTC-5:00) Eastern Time (US & Canada)', value: 35, UTC_OFFSET: -300, abbreviation: '' },
  {
    label: '(UTC-5:00) Havana',
    value: 44,
    UTC_OFFSET: -300,
    abbreviation: 'ACT',
  },
  { label: '(UTC-4:00) Caracas', value: 47, UTC_OFFSET: -240, abbreviation: '' },
  {
    label: '(UTC-4:00) Turks and Caicos',
    value: 51,
    UTC_OFFSET: -240,
    abbreviation: 'VET',
  },
  {
    label: '(UTC-4:00) Georgetown, La Paz, Manaus, San Juan',
    value: 55,
    UTC_OFFSET: -240,
    abbreviation: 'VET',
  },
  { label: '(UTC-4:00) Asuncion', value: 59, UTC_OFFSET: -240, abbreviation: '' },
  {
    label: '(UTC-4:00) Santiago',
    value: 56,
    UTC_OFFSET: -240,
    abbreviation: 'VET',
  },
  { label: '(UTC-4:00) Cuiaba', value: 58, UTC_OFFSET: -240, abbreviation: '' },
  {
    label: '(UTC-4:00) Atlantic Time (Canada)',
    value: 50,
    UTC_OFFSET: -240,
    abbreviation: 'VET',
  },
  { label: '(UTC-3:00) Newfoundland', value: 60, UTC_OFFSET: -210, abbreviation: '' },
  {
    label: '(UTC-3:00) Araguaina',
    value: 77,
    UTC_OFFSET: -180,
    abbreviation: 'GDT',
  },
  {
    label: '(UTC-3:00) Saint Pierre and Miquelon',
    value: 72,
    UTC_OFFSET: -180,
    abbreviation: 'GDT',
  },
  { label: '(UTC-3:00) Cayenne, Fortaleza', value: 70, UTC_OFFSET: -180, abbreviation: 'GDT' },
  {
    label: '(UTC-3:00) Montevideo',
    value: 74,
    UTC_OFFSET: -180,
    abbreviation: 'GDT',
  },
  { label: '(UTC-3:00) Greenland', value: 73, UTC_OFFSET: -180, abbreviation: '' },
  {
    label: '(UTC-3:00) Brasilia',
    value: 65,
    UTC_OFFSET: -180,
    abbreviation: 'GDT',
  },
  { label: '(UTC-3:00) Salvador', value: 71, UTC_OFFSET: -180, abbreviation: 'GDT' },
  {
    label: '(UTC-3:00) Buenos Aires',
    value: 69,
    UTC_OFFSET: -180,
    abbreviation: 'GDT',
  },
  {
    label: '(UTC-2:00) Coordinated Universal Time-02',
    value: 76,
    UTC_OFFSET: -120,
    abbreviation: 'UTC-02',
  },
  { label: '(UTC-2:00) Mid-Atlantic', value: 75, UTC_OFFSET: -120, abbreviation: 'UTC-02' },
  {
    label: '(UTC-1:00) Cabo Verde Is.',
    value: 83,
    UTC_OFFSET: -60,
    abbreviation: 'CVT',
  },
  { label: '(UTC-1:00) Azores', value: 80, UTC_OFFSET: -60, abbreviation: 'CVT' },
  {
    label: '(UTC+0:00) Coordinated Universal Time',
    value: 92,
    UTC_OFFSET: 0,
    abbreviation: 'UTC',
  },
  { label: '(UTC+0:00) Casablanca', value: 84, UTC_OFFSET: 0, abbreviation: 'UTC' },
  {
    label: '(UTC+0:00) Monrovia, Reykjavik',
    value: 90,
    UTC_OFFSET: 0,
    abbreviation: 'UTC',
  },
  {
    label: '(UTC+0:00) Dublin, Edinburgh, Lisbon, London',
    value: 85,
    UTC_OFFSET: 0,
    abbreviation: 'UTC',
  },
  {
    label: '(UTC+1:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 110,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  {
    label: '(UTC+1:00) West Central Africa',
    value: 113,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  {
    label: '(UTC+1:00) Brussels, Copenhagen, Madrid, Paris',
    value: 105,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  {
    label: '(UTC+1:00) Windhoek',
    value: 141,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  {
    label: '(UTC+1:00) Sarajevo, Skopje, Warsaw, Zagreb',
    value: 100,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  {
    label: '(UTC+1:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    value: 95,
    UTC_OFFSET: 60,
    abbreviation: 'CET',
  },
  { label: '(UTC+2:00) Athens, Bucharest', value: 142, UTC_OFFSET: 120, abbreviation: 'EET' },
  {
    label: '(UTC+2:00) Damascus',
    value: 133,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  { label: '(UTC+2:00) Harare, Pretoria', value: 140, UTC_OFFSET: 120, abbreviation: 'EET' },
  {
    label: '(UTC+2:00) Beirut',
    value: 131,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  { label: '(UTC+2:00) Kaliningrad', value: 159, UTC_OFFSET: 120, abbreviation: 'EET' },
  {
    label: '(UTC+2:00) Amman',
    value: 129,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  { label: '(UTC+2:00) Jerusalem', value: 135, UTC_OFFSET: 120, abbreviation: 'EET' },
  {
    label: '(UTC+2:00) Gaza, Hebron',
    value: 130,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  {
    label: '(UTC+2:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    value: 125,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  { label: '(UTC+2:00) Cairo', value: 120, UTC_OFFSET: 120, abbreviation: 'EET' },
  {
    label: '(UTC+2:00) Chisinau',
    value: 115,
    UTC_OFFSET: 120,
    abbreviation: 'EET',
  },
  {
    label: '(UTC+3:00) Istanbul',
    value: 134,
    UTC_OFFSET: 180,
    abbreviation: 'MSK',
  },
  {
    label: '(UTC+3:00) Moscow, St. Petersburg, Volgograd',
    value: 145,
    UTC_OFFSET: 180,
    abbreviation: 'MSK',
  },
  { label: '(UTC+3:00) Nairobi', value: 155, UTC_OFFSET: 180, abbreviation: 'MSK' },
  {
    label: '(UTC+3:00) Minsk',
    value: 151,
    UTC_OFFSET: 180,
    abbreviation: 'MSK',
  },
  { label: '(UTC+3:00) Baghdad', value: 158, UTC_OFFSET: 180, abbreviation: 'MSK' },
  {
    label: '(UTC+3:00) Kuwait, Riyadh',
    value: 150,
    UTC_OFFSET: 180,
    abbreviation: 'MSK',
  },
  { label: '(UTC+3:30) Tehran', value: 160, UTC_OFFSET: 210, abbreviation: 'IRDT' },
  {
    label: '(UTC+4:00) Izhevsk, Samara',
    value: 174,
    UTC_OFFSET: 240,
    abbreviation: 'MUT',
  },
  { label: '(UTC+4:00) Port Louis', value: 172, UTC_OFFSET: 240, abbreviation: 'MUT' },
  {
    label: '(UTC+4:00) Tbilisi',
    value: 173,
    UTC_OFFSET: 240,
    abbreviation: 'MUT',
  },
  { label: '(UTC+4:00) Yerevan', value: 170, UTC_OFFSET: 240, abbreviation: 'GST' },
  {
    label: '(UTC+4:00) Baku',
    value: 169,
    UTC_OFFSET: 240,
    abbreviation: 'GST',
  },
  {
    label: '(UTC+4:00) Astrakhan, Ulyanovsk',
    value: 176,
    UTC_OFFSET: 240,
    abbreviation: 'GST',
  },
  { label: '(UTC+4:00) Abu Dhabi, Muscat', value: 165, UTC_OFFSET: 240, abbreviation: 'GST' },
  {
    label: '(UTC+4:30) Kabul',
    value: 175,
    UTC_OFFSET: 270,
    abbreviation: 'AFT',
  },
  {
    label: '(UTC+5:00) Ashgabat, Tashkent',
    value: 185,
    UTC_OFFSET: 300,
    abbreviation: 'PKT',
  },
  { label: '(UTC+5:00) Islamabad, Karachi', value: 184, UTC_OFFSET: 300, abbreviation: 'PKT' },
  {
    label: '(UTC+5:00) Ekaterinburg',
    value: 180,
    UTC_OFFSET: 300,
    abbreviation: 'PKT',
  },
  {
    label: '(UTC+5:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 190,
    UTC_OFFSET: 330,
    abbreviation: 'IST',
  },
  {
    label: '(UTC+5:30) Sri Jayawardenepura',
    value: 200,
    UTC_OFFSET: 330,
    abbreviation: 'IST',
  },
  { label: '(UTC+5:30) Kathmandu', value: 193, UTC_OFFSET: 345, abbreviation: 'NPT' },
  {
    label: '(UTC+6:00) Omsk',
    value: 197,
    UTC_OFFSET: 360,
    abbreviation: 'OMST',
  },
  { label: '(UTC+6:00) Astana', value: 195, UTC_OFFSET: 360, abbreviation: 'OMST' },
  {
    label: '(UTC+6:00) Dhaka',
    value: 196,
    UTC_OFFSET: 360,
    abbreviation: 'BDT',
  },
  { label: '(UTC+6:30) Yangon (Rangoon)', value: 203, UTC_OFFSET: 390, abbreviation: '' },
  {
    label: '(UTC+7:00) Hovd',
    value: 209,
    UTC_OFFSET: 420,
    abbreviation: 'MMT',
  },
  { label: '(UTC+7:00) Tomsk', value: 211, UTC_OFFSET: 420, abbreviation: '' },
  {
    label: '(UTC+7:00) Bangkok, Hanoi, Jakarta',
    value: 205,
    UTC_OFFSET: 420,
    abbreviation: 'ICT',
  },
  { label: '(UTC+7:00) Krasnoyarsk', value: 207, UTC_OFFSET: 420, abbreviation: 'ICT' },
  {
    label: '(UTC+7:00) Novosibirsk',
    value: 201,
    UTC_OFFSET: 420,
    abbreviation: 'ICT',
  },
  { label: '(UTC+7:00) Barnaul, Gorno-Altaysk', value: 208, UTC_OFFSET: 420, abbreviation: 'ICT' },
  {
    label: '(UTC+8:00) Perth',
    value: 225,
    UTC_OFFSET: 480,
    abbreviation: 'AWST',
  },
  { label: '(UTC+8:00) Ulaanbaatar', value: 228, UTC_OFFSET: 480, abbreviation: 'AWST' },
  {
    label: '(UTC+8:00) Taipei',
    value: 220,
    UTC_OFFSET: 480,
    abbreviation: 'AWST',
  },
  { label: '(UTC+8:00) Kuala Lumpur, Singapore', value: 215, UTC_OFFSET: 480, abbreviation: 'AWST' },
  {
    label: '(UTC+8:00) Irkutsk',
    value: 227,
    UTC_OFFSET: 480,
    abbreviation: 'AWST',
  },
  {
    label: '(UTC+8:00) Beijing, Chongqing, Hong Kong SAR of China, Urumqi',
    value: 210,
    UTC_OFFSET: 480,
    abbreviation: 'AWST',
  },
  { label: '(UTC+8:30) Pyongyang', value: 229, UTC_OFFSET: 510, abbreviation: 'KST' },
  {
    label: '(UTC+8:30) Eucla',
    value: 231,
    UTC_OFFSET: 525,
    abbreviation: 'KST',
  },
  { label: '(UTC+9:00) Yakutsk', value: 240, UTC_OFFSET: 540, abbreviation: 'JST' },
  {
    label: '(UTC+9:00) Chita',
    value: 241,
    UTC_OFFSET: 540,
    abbreviation: 'JST',
  },
  { label: '(UTC+9:00) Osaka, Sapporo, Tokyo', value: 235, UTC_OFFSET: 540, abbreviation: 'JST' },
  {
    label: '(UTC+9:00) Seoul',
    value: 230,
    UTC_OFFSET: 540,
    abbreviation: 'JST',
  },
  { label: '(UTC+9:30) Adelaide', value: 250, UTC_OFFSET: 570, abbreviation: 'ACDT' },
  {
    label: '(UTC+9:30) Darwin',
    value: 245,
    UTC_OFFSET: 570,
    abbreviation: 'ACST',
  },
  { label: '(UTC+10:00) Guam, Port Moresby', value: 275, UTC_OFFSET: 600, abbreviation: 'AEST' },
  {
    label: '(UTC+10:00) Vladivostok',
    value: 270,
    UTC_OFFSET: 600,
    abbreviation: 'AEST',
  },
  { label: '(UTC+10:00) Hobart', value: 265, UTC_OFFSET: 600, abbreviation: 'AEST' },
  {
    label: '(UTC+10:00) Brisbane',
    value: 260,
    UTC_OFFSET: 600,
    abbreviation: 'AEST',
  },
  {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 255,
    UTC_OFFSET: 600,
    abbreviation: '',
  },
  { label: '(UTC+10:30) Lord Howe Island', value: 274, UTC_OFFSET: 630, abbreviation: 'LHST' },
  {
    label: '(UTC+11:00) Sakhalin',
    value: 278,
    UTC_OFFSET: 660,
    abbreviation: 'Sakhalin',
  },
  { label: '(UTC+11:00) Chokurdakh', value: 279, UTC_OFFSET: 660, abbreviation: 'Sakhalin' },
  {
    label: '(UTC+11:00) Norfolk Island',
    value: 277,
    UTC_OFFSET: 660,
    abbreviation: 'Sakhalin',
  },
  {
    label: '(UTC+11:00) Magadan',
    value: 281,
    UTC_OFFSET: 660,
    abbreviation: 'Sakhalin',
  },
  {
    label: '(UTC+11:00) Solomon Is., New Caledonia',
    value: 280,
    UTC_OFFSET: 660,
    abbreviation: 'Sakhalin',
  },
  {
    label: '(UTC+11:00) Bougainville Island',
    value: 276,
    UTC_OFFSET: 660,
    abbreviation: 'Sakhalin',
  },
  {
    label: '(UTC+12:00) Coordinated Universal Time+12',
    value: 284,
    UTC_OFFSET: 720,
    abbreviation: 'NZST',
  },
  {
    label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    value: 295,
    UTC_OFFSET: 720,
    abbreviation: 'NZST',
  },
  { label: '(UTC+12:00) Auckland, Wellington', value: 290, UTC_OFFSET: 720, abbreviation: 'NZST' },
  {
    label: '(UTC+12:00) Fiji',
    value: 285,
    UTC_OFFSET: 720,
    abbreviation: 'NZST',
  },
  { label: '(UTC+12:30) Chatham Islands', value: 299, UTC_OFFSET: 765, abbreviation: 'NZST' },
  {
    label: "(UTC+13:00) Nuku'alofa",
    value: 300,
    UTC_OFFSET: 780,
    abbreviation: 'SST',
  },
  { label: '(UTC+13:00) Samoa', value: 1, UTC_OFFSET: 780, abbreviation: 'SST' },
];
const priorityoptions = [
  {
    label: 'P4- Minor',
    value: '4',
    description: 'Minimal or no interruptions to normal operations.',
  },
  {
    label: 'P3- Important',
    value: '3',
    description: 'Interruptions to normal operations.',
  },
  {
    label: 'P2- Urgent',
    value: '2',
    description: 'Serious interruptions to normal operations.',
  },
  {
    label: 'P1- Critical',
    value: '1',
    description: 'Outage or extremely serious interruptions to operations.',
  },
];
export const MILO_FIELDS_DATA = [
  {
    id: 'support-product-priority',
    label: 'Select the priority',
    title: 'Urgency',
    options: priorityoptions,
  },
  {
    id: 'support-product-impact',
    label: 'Select Business Impact',
    title: 'Select Business impact',
    options: [
      {
        label: 'Small',
        value: '3',
        description: 'One or two users impacted.',
      },
      {
        label: 'Medium',
        value: '2',
        description: 'A specific group of users impacted.',
      },
      {
        label: 'Large',
        value: '1',
        description: 'Majority of users impacted.',
      },
    ],
  },
  {
    id: 'support-product-timeZone',
    label: 'Time zone',
    title: 'Timezone',
    options: TIMEZONEOPTIONS,

  },
];

export const PRIORITY_OPTIONS = [
  {
    id: 'support-product-priority',
    label: 'Select the priority',
    title: 'Urgency',
    options: priorityoptions,
  },
  // {
  //   id: 'support-product-impact',
  //   label: 'Select business impact',
  //   key: 'productImpact',
  //   type: 'SHORT_TEXT',
  //   textAreaId: 'support-product-impact-input',
  //   placeholder:''
  // } 
  {
    id: 'support-product-impact',
    label: 'Select Business impact',
    title: 'Select Business impact',
    options: [
      {
        label: 'Small',
        value: '3',
        description: 'One or two users impacted.',
      },
      {
        label: 'Medium',
        value: '2',
        description: 'A specific group of users impacted.',
      },
      {
        label: 'Large',
        value: '1',
        description: 'Majority of users impacted.',
      },
    ],
  }
];

export const TIMEZONE_OPTIONS = [
  {
    id: 'support-product-timeZone',
    label: 'Timezone',
    title: 'Timezone',
    options: TIMEZONEOPTIONS,
  }
]

export const ALLOWED_FILE_SIZE = 20000000; // Byte

export const MENTORSESSIONPRODUCTS = [
  {
    id: 'session-product-picker',
    type: 'DROPDOWN',
    label: 'Select Product',
    title: 'Select Product...',
    options: [
      {
        label: 'AEP: Real-Time CDP',
        id: '14',
      },
      {
        label: 'Admin Console',
        id: '13',
      },
      {
        label: 'AEP: Core',
        id: '12',
      },
      {
        label: 'AEM: Sites',
        id: '11',
      },
      {
        label: 'AEM: Assets',
        id: '10',
      },
      {
        label: 'AEM: Forms',
        id: '9',
      },
      {
        label: 'Campaign Standard',
        id: '8',
      },
      {
        label: 'Campaign Classic',
        id: '7',
      },
      {
        label: 'Analytics',
        id: '6',
      },
      {
        label: 'Target',
        id: '5',
      },
      {
        label: 'Audience Manager',
        id: '4',
      },
      {
        label: 'Marketo Engage',
        id: '3',
      },
      {
        label: 'Commerce',
        id: '2',
      },
      {
        label: 'Workfront',
        id: '1',
      },
    ],
  },
];

export const MENTORSESSIONTOPICS = [
  {
    label: 'AEM: Sites',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic...',
        type: 'DROPDOWN',
        options: [
          {
            label: 'AEM Caches Optimization.',
            value: '7',
          },
          {
            label: 'Translation in AEM Best Practices.',
            value: '6',
          },
          {
            label: 'Graph QL Capabilities in AEM Headless.',
            value: '5',
          },
          {
            label: 'Single-Page-App (SPA) Editor Overview.',
            value: '4',
          },
          {
            label: 'Configuring Maintenance Activity and Best Practicies for Improving Instance Durability.',
            value: '3',
          },
          {
            label: 'MSM for assets and site setup and guidelines.',
            value: '2',
          },
          {
            label: 'Best practices and guidelines for AEM development tools, components, templates and bundles',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'AEM: Assets',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Dynamic Media Selective Sync Overview',
            value: '14',
          },
          {
            label: 'Creating Asset Sets using Dynamic Media',
            value: '13',
          },
          {
            label: 'Video Profiles in Dynamic Media',
            value: '12',
          },
          {
            label: 'Smart Imaging in Dynamic Media',
            value: '11',
          },
          {
            label: 'Configure Dynamic Media',
            value: '10',
          },
          {
            label: 'Sharing Assets on Brand Portal ',
            value: '9',
          },
          {
            label: 'Brand Portal Admin Features Overview',
            value: '8',
          },
          {
            label: 'Brand Portal - Using Share Link Feature',
            value: '7',
          },
          {
            label: 'Asset Migration - Best Practices and Recommendations',
            value: '6',
          },
          {
            label: 'AEM Asset Essentials',
            value: '5',
          },
          {
            label: 'Delivering Content Fragments in AEM',
            value: '4',
          },
          {
            label: 'Configure Dynamic Media',
            value: '3',
          },
          {
            label: 'Dynamic Media Best Practices',
            value: '2',
          },
          {
            label: 'Configure Brand Portal',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'AEM: Forms',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Configuring Watched Folder in AEM Forms OSGi/JEE',
            value: '11',
          },
          {
            label: 'Hardening AEM Forms Environment',
            value: '10',
          },
          {
            label: 'AEM Forms Integration with Adobe Sign',
            value: '9',
          },
          {
            label: 'Configuring PDF Generator in AEM Forms OSGi',
            value: '8',
          },
          {
            label: 'Performance Tuning of AEM Forms Server',
            value: '7',
          },
          {
            label: 'Configure Automated Forms Conversion',
            value: '6',
          },
          {
            label: 'Form Data Models (FDM)',
            value: '5',
          },
          {
            label: 'Architecture and Deployment Topologies for Forms',
            value: '4',
          },
          {
            label: 'Installing and Configuring Document Services',
            value: '3',
          },
          {
            label: 'Adaptive Forms Best Practices',
            value: '2',
          },
          {
            label: 'Configure and render XDP/PDF as HTML in browser',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'AEP: Core',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Query Services via API',
            value: '2',
          },
          {
            label: 'Segment Match',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Campaign Standard',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Delivery Best Practices',
            value: '4',
          },
          {
            label: 'Audit Trail Feature Overview',
            value: '3',
          },
          {
            label: 'Workflow Best Practices',
            value: '2',
          },
          {
            label: 'Calculating Real time event performance',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Campaign Classic',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Instance Monitoring Tools',
            value: '5',
          },
          {
            label: 'Workflow Heatmap Overview',
            value: '4',
          },
          {
            label: 'Audit Trail Feature Overview',
            value: '3',
          },
          {
            label: 'Integrate Campaign and Analytics',
            value: '2',
          },
          {
            label: 'SMS via Adobe Campaign',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Analytics',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Data Dictionary',
            value: '25',
          },
          {
            label: 'Live Stream API',
            value: '24',
          },
          {
            label: 'Adobe Analytics Basics',
            value: '23',
          },
          {
            label: 'Adobe Analytics vs CJA',
            value: '22',
          },
          {
            label: 'Low Traffic/Hash Collision and BAVIDs',
            value: '21',
          },
          {
            label: 'Client Hints Overview',
            value: '20',
          },
          {
            label: 'Attribution IQ Overview',
            value: '19',
          },
          {
            label: 'UTM Parameters Overview',
            value: '18',
          },
          {
            label: 'Reporting Activity Manager',
            value: '17',
          },
          {
            label: 'Analytics for Target (A4T) Data Management',
            value: '16',
          },
          {
            label: 'How Segmentation Works',
            value: '15',
          },
          {
            label: 'Exclude by IP/Cookies',
            value: '14',
          },
          {
            label: 'Traffic Management',
            value: '13',
          },
          {
            label: 'Real-Time Reports',
            value: '12',
          },
          {
            label: 'Email Restrictions',
            value: '11',
          },
          {
            label: 'Adobe I/O Configuration',
            value: '10',
          },
          {
            label: 'Activity Map and Reports',
            value: '9',
          },
          {
            label: 'Share Segments and Experience Cloud Publishing',
            value: '8',
          },
          {
            label: 'Curated Virtual Report Suites',
            value: '7',
          },
          {
            label: 'Privacy Service API and Data Governance Settings',
            value: '6',
          },
          {
            label: 'AA Alerts and Best Practices',
            value: '5',
          },
          {
            label: 'Contribution Analysis',
            value: '4',
          },
          {
            label: 'BOT Rules',
            value: '3',
          },
          {
            label: 'Marketing Channels',
            value: '2',
          },
          {
            label: 'Analysis Workspace Freeform Tables & Visualizations',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Target',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Auto-Allocate and Auto-Target Overview',
            value: '20',
          },
          {
            label: 'Multivariate Testing',
            value: '19',
          },
          {
            label: 'Cookieless Strategy',
            value: '18',
          },
          {
            label: 'Activities Collision and Priority Handling in Target',
            value: '17',
          },
          {
            label: 'Adobe Recommendations Criteria/Algo Overview',
            value: '16',
          },
          {
            label: 'Customer Attributes',
            value: '15',
          },
          {
            label: 'AEM/Target Integration Overview',
            value: '14',
          },
          {
            label: 'Target QA Guide Review',
            value: '13',
          },
          {
            label: 'How Geolocation Works',
            value: '12',
          },
          {
            label: 'Target on Mobile',
            value: '11',
          },
          {
            label: 'Audiences Overview',
            value: '10',
          },
          {
            label: 'Auto-Target and Automated Personalization',
            value: '9',
          },
          {
            label: 'Analytics for Target (A4T) Overview',
            value: '8',
          },
          {
            label: 'On-Device Decisioning for at.js',
            value: '7',
          },
          {
            label: 'Interpreting Target Reports',
            value: '6',
          },
          {
            label: 'Target Recommendations',
            value: '5',
          },
          {
            label: 'User Permissions',
            value: '4',
          },
          {
            label: 'Target Administration Overview',
            value: '3',
          },
          {
            label: 'Different Types of Activities Overview',
            value: '2',
          },
          {
            label: 'Target Business Methodology',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Audience Manager',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Adobe Audience Manager Crash Course',
            value: '3',
          },
          {
            label: 'ID Syncs and Match Rates',
            value: '2',
          },
          {
            label: 'BAAAM',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Marketo Engage',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Marketo System Configuration Best Practices',
            value: '11',
          },
          {
            label: 'Web Personalization and Content AI',
            value: '10',
          },
          {
            label: 'Revenue Cycle Analytics Overview',
            value: '9',
          },
          {
            label: 'Lead Database Overview',
            value: '8',
          },
          {
            label: 'Email Insights Tool Review',
            value: '7',
          },
          {
            label: 'Deliverability Overview',
            value: '6',
          },
          {
            label: 'Marketo Marketing Calendar Overview',
            value: '5',
          },
          {
            label: 'Marketo API Overview',
            value: '4',
          },
          {
            label: 'TAM (formerly ABM) Overview',
            value: '3',
          },
          {
            label: 'Engagement Programs',
            value: '2',
          },
          {
            label: 'A/B Testing',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Commerce',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Merchandising Rules',
            value: '13',
          },
          {
            label: 'Catalog Services + Payment Services',
            value: '12',
          },
          {
            label: 'Data Connection',
            value: '11',
          },
          {
            label: 'Admin Portal Orientation',
            value: '10',
          },
          {
            label: 'Customer Service Tools',
            value: '9',
          },
          {
            label: 'B2B Features',
            value: '8',
          },
          {
            label: 'GraphQL',
            value: '7',
          },
          {
            label: 'Docker Local Setup',
            value: '6',
          },
          {
            label: 'AEM & Commerce Integration Patterns',
            value: '5',
          },
          {
            label: 'Fastly Caching Configuration',
            value: '4',
          },
          {
            label: 'Auto-scaling Feature Overview',
            value: '3',
          },
          {
            label: 'SWAT reports',
            value: '2',
          },
          {
            label: 'Block malicious traffic for Adobe Commerce',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Admin Console',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'User Management under User Sync',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'Workfront',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Report Builder',
            value: '2',
          },
          {
            label: 'Templates',
            value: '1',
          },
        ],
      },
    ],
  },
  {
    label: 'AEP: Real-Time CDP',
    topics: [
      {
        id: 'session-topic-picker',
        label: 'Select topic',
        title: 'Select topic',
        type: 'DROPDOWN',
        options: [
          {
            label: 'Data Governance (DULE)',
            value: '8',
          },
          {
            label: 'Attribute-Based Access Control (ABAC)',
            value: '7',
          },
          {
            label: 'Query Service + Data Distiller',
            value: '6',
          },
          {
            label: 'Data Ingestion + Sources overview',
            value: '5',
          },
          {
            label: 'Data Activation + Destinations overview',
            value: '4',
          },
          {
            label: 'Schema management & evolution',
            value: '3',
          },
          {
            label: 'Alerts and monitoring capabilities',
            value: '2',
          },
          {
            label: 'Data license usage & management',
            value: '1',
          },
        ],
      },
    ],
  },
];

export const MENTORSESSIONFIELDS = [
  {
    id: 'session-case-description',
    type: 'TEXT',
    label: 'Describe any additional details of your request.',
  },
  {
    id: 'session-timezone-picker',
    type: 'DROPDOWN',
    label: 'Select Timezone',
    title: 'Select Timezone',
    options: TIMEZONEOPTIONS,
  },
];

export const DEVELOPERSESSIONFIELDS1 = [
  {
    id: 'session-problem',
    label: 'Problem Statement',
    para: "Please describe the technical issue you're trying to solve",
    type: 'TEXT',
  },
  {
    id: 'session-desired-outcome',
    label: 'Desired Outcome',
    para: 'What do you expect to get out of the engagement?',
    type: 'TEXT',
    placeholder: `This should include:
    Summary of business and functional requirements/use cases
    Existing challenges(as applicable)
    Success criteria`,
  },
  {
    id: 'session-priority-picker',
    label: 'Select The Priority',
    title: 'Urgency',
    type: 'DROPDOWN',
    options: priorityoptions,
  },
];

export const DEVELOPERSESSIONFIELDS2 = [
  {
    id: 'session-timezone-picker',
    type: 'DROPDOWN',
    label: 'Select Timezone',
    title: 'Select Timezone',
    options: TIMEZONEOPTIONS,
  },
];

export const PHONE_NUMBER_FORMATS = {
  'zh-Hans': [
    {
      match: /^(\d{2})(\d{3})(\d{7})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}-${matches[3]}`,
    },
    {
      match: /^(\d{2})(\d{11})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}`,
    },
  ],
  'zh-Hant': [
    {
      match: /^(\d{4})(\d{3})(\d{3})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]}`,
    },
    {
      match: /^(\d{3})(\d{3})(\d{3})(\d{3})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}-${matches[3]}-${matches[4]}`,
    },
  ],
  'zh-hans': [
    {
      match: /^(\d{2})(\d{3})(\d{7})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}-${matches[3]}`,
    },
    {
      match: /^(\d{2})(\d{11})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}`,
    },
  ],
  'zh-hant': [
    {
      match: /^(\d{4})(\d{3})(\d{3})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]}`,
    },
    {
      match: /^(\d{3})(\d{3})(\d{3})(\d{3})$/,
      format: (matches) => `+${matches[1]}-${matches[2]}-${matches[3]}-${matches[4]}`,
    },
  ],
  nl: [
    {
      match: /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
      format: (matches) => `(${matches[1]}) ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]}`,
    },
  ],
  en: [
    {
      match: /^(\d{1,3})(\d{3})(\d{3})(\d{4})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]}`,
    },
    {
      match: /^(\d{3})(\d{3})(\d{4})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]}`,
    },
  ],
  es: [
    {
      match: /^(\d{3})(\d{3})(\d{3})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]}`,
    },
    {
      match: /^(\d{1,3})(\d{3})(\d{3})(\d{3})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]}`,
    },
  ],
  fr: [
    {
      match: /^(\d{1,2})(\d{1})(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/,
      format: (matches) =>
        `+${matches[1]} (${matches[2]})${matches[3]} ${matches[4]} ${matches[5]} ${matches[6]} ${matches[7]}`,
    },
    {
      match: /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]}`,
    },
    {
      match: /^(\d{4})(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]} ${matches[6]}`,
    },
  ],
  de: [
    {
      match: /^(\d{4})(\d{3})(\d{6})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]}`,
    },
    {
      match: /^(\d{4})(\d{7})$/,
      format: (matches) => `${matches[1]} ${matches[2]}`,
    },
    {
      match: /^(\d{1,3})(\d{4})(\d{8})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]}`,
    },
    {
      match: /^(\d{1,3})(\d{3})(\d{7})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]}`,
    },
  ],
  it: [
    {
      match: /^(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})(\d{1})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]} ${matches[6]}`,
    },
    {
      match: /^(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]}`,
    },
  ],
  ja: [
    {
      match: /^(\d{3})(\d{4})(\d{4})$/,
      format: (matches) => `(${matches[1]}) ${matches[2]}-${matches[3]} `,
    },
    {
      match: /^(\d{3})(\d{3})(\d{4})$/,
      format: (matches) => `${matches[1]}-${matches[2]}-${matches[3]}`,
    },
  ],
  ko: [
    {
      match: /^(\d{2})(\d{1})(\d{1})(\d{3})(\d{4})$/,
      format: (matches) => `+${matches[1]} (${matches[2]})${matches[3]}-${matches[4]}-${matches[5]}`,
    },
    {
      match: /^(\d{2})(\d{1})(\d{2})(\d{4})(\d{4})$/,
      format: (matches) => `+${matches[1]} (${matches[2]})${matches[3]}-${matches[4]}-${matches[5]}`,
    },
  ],
  'pt-BR': [
    {
      match: /^0(\d{2})(\d{5})(\d{4})$/,
      format: (matches) => `0${matches[1]} ${matches[2]}-${matches[3]} `,
    },
    {
      match: /^(\d{2})(\d{5})(\d{5})$/,
      format: (matches) => `(${matches[1]}) ${matches[2]}-${matches[3]} `,
    },
    {
      match: /^(\d{2})(\d{2})(\d{9})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]} `,
    },
  ],
  'pt-br': [
    {
      match: /^0(\d{2})(\d{5})(\d{4})$/,
      format: (matches) => `0${matches[1]} ${matches[2]}-${matches[3]} `,
    },
    {
      match: /^(\d{2})(\d{5})(\d{5})$/,
      format: (matches) => `(${matches[1]}) ${matches[2]}-${matches[3]} `,
    },
    {
      match: /^(\d{2})(\d{2})(\d{9})$/,
      format: (matches) => `${matches[1]} ${matches[2]} ${matches[3]} `,
    },
  ],
  sv: [
    {
      match: /^(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]} ${matches[5]}`,
    },
    {
      match: /^(\d{2})(\d{2})(\d{3})(\d{2})$/,
      format: (matches) => `+${matches[1]} ${matches[2]} ${matches[3]} ${matches[4]}`,
    },
    {
      match: /^(\d{3})(\d{3})(\d{2})(\d{2})$/,
      format: (matches) => `${matches[1]}-${matches[2]} ${matches[3]} ${matches[4]}`,
    },
  ],
};

export const COMMERCEFIELDS = [
  {
    id: 'staging-storefront',
    label: 'Staging storefront',
    type: 'SHORT_TEXT',
  },
  {
    id: 'staging-MBO',
    label: 'Staging MBO',
    type: 'SHORT_TEXT',
  },
  {
    id: 'productions-storefront',
    label: 'Productions storefront',
    type: 'SHORT_TEXT',
  },
  {
    id: 'production-MBO',
    label: 'Production MBO',
    type: 'SHORT_TEXT',
  },
];

const projectUrl = {
  id: 'commerce-project-url',
  label: 'Project URL',
  sublabel:'Used to run Site Wide Analysis Tool (SWAT)',
  placeholder:'Provide the project URL that requires support',
  type: 'SHORT_TEXT',
  key: 'projectUrlId',
  para: `URL to your project can be found under https://accounts.magento.cloud/. It will typically be in the format:
        [https://[REGION].magento.cloud/projects/PROJECT_ID]`,
};

const affectedUrl = {
  id: 'commerce-affected-url',
  label: 'Affected URL',
  type: 'SHORT_TEXT',
  key: 'affectedUrlId',
  para: 'URL must begin with http:// or https://',
};

const paypalMerchantId = {
  id: 'commerce-paypal-merchant-id',
  label: 'Paypal Merchant ID',
  type: 'SHORT_TEXT',
  key: 'paypalMerchantId',
};

const projectId = {
  id: 'commerce-project-id',
  label: 'Project ID',
  type: 'SHORT_TEXT',
  key: 'projectId',
};

export const AMCFIELDS = [
  {
    productLabel: 'Commerce Cloud',
    productId: 'dx_commercecloud_support',
    field: [projectUrl, projectId, affectedUrl],
  },
  {
    productLabel: 'Commerce On-Prem',
    productId: 'dx_commerceonprem_support',
    field: [affectedUrl],
  },
  {
    productLabel: 'Commerce Payment Services',
    productId: 'dx_commercepaymentservices_support',
    field: [paypalMerchantId, affectedUrl],
  },
  {
    productLabel: 'Commerce Reporting',
    productId: 'dx_commercereporting_support',
    field: [affectedUrl],
  },
  {
    productLabel: 'Commerce on Managed Services',
    productId: 'dx_commercemanagedservices_support',
    field: [projectUrl, projectId, affectedUrl],
  },
];

export const SUCCESSCARDS = [
  {
    type: 'In Person',
    location: 'Bay Area - California',
    title: 'Leaders and Learners',
    subtitle: 'Cross industry peer learning and networking',
    details: {
      joinUsText: 'Join Us',
      date: 'Thursday, August 01, 2024',
      time: '',
    },
    button: {
      dataId: 'registerNow',
      class:
        'mb-2 spectrum-Button  spectrum-Button--sizeM ultimate-success-button-blue has-text-white is-borderless pt-1 has-text-weight-normal',
      text: 'Register now',
    },
    color: {
      background: 'linear-border-learner',
    },
    eventLink: 'https://event.adobe.com/leaderslearnersforuminbayarea',
    buttonClass: 'register-btn pb-1',
  },
  {
    type: 'In Person',
    location: 'Melbourne',
    title: 'Skill-Up',
    subtitle: 'Solution hands-on enablement, best practices, tips and tricks',
    details: {
      joinUsText: 'Join Us',
      date: 'Thursday, July 25, 2024',
      time: '',
    },
    button: {
      dataId: 'comingsoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming Soon',
    },
    color: {
      background: 'linear-border',
    },
    eventLink: '',
    buttonClass: '',
  },
  {
    type: 'In Person',
    location: 'Seattle',
    title: 'Skill-Up',
    subtitle: 'Solution hands-on enablement, best practices, tips and tricks',
    details: {
      joinUsText: 'Join Us',
      date: 'Thursday, August 08, 2024',
      time: '',
    },
    button: {
      dataId: 'registerNow',
      class:
        'mb-2 spectrum-Button  spectrum-Button--sizeM ultimate-success-button-blue has-text-white is-borderless pt-1 has-text-weight-normal',
      text: 'Register now',
    },
    color: {
      background: 'linear-border-learner',
    },
    eventLink: 'https://event.adobe.com/leaderslearnersforuminbayarea',
    buttonClass: 'register-btn pb-1',
  },
  {
    type: 'In Person',
    location: 'Munich',
    title: 'Skill-Up',
    subtitle: 'Solution hands-on enablement, best practices, tips and tricks',
    details: {
      joinUsText: 'Join Us',
      date: 'Thursday, July 25, 2024',
      time: '',
    },
    button: {
      dataId: 'comingSoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming soon',
    },
    color: {
      background: 'linear-border',
    },
    eventLink: '',
    buttonClass: '',
  },
  {
    type: 'In Person',
    location: 'Singapore',
    title: 'Leaders and Learners',
    subtitle: 'Cross industry peer learning and networking',
    details: {
      joinUsText: 'Join Us',
      date: 'Thrusday, August 22, 2024',
      time: '',
    },
    button: {
      dataId: 'comingSoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming soon',
    },
    color: {
      background: 'linear-border-learner',
    },
    eventLink: '',
    buttonClass: '',
  },
  {
    type: 'In Person',
    location: 'Sydney',
    title: 'Skill-Up',
    subtitle: 'Solution hands-on enablement, best practices, tips and tricks',
    details: {
      joinUsText: 'Join Us',
      date: 'Friday, August 02, 2024',
      time: '',
    },
    button: {
      dataId: 'comingSoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming soon',
    },
    color: {
      background: 'linear-border',
    },
    eventLink: '',
    buttonClass: '',
  },
  {
    type: 'In Person',
    location: 'Sydney',
    title: 'Leaders and Learners',
    subtitle: 'Solution hands-on enablement, best practices, tips and tricks',
    details: {
      joinUsText: 'Join Us',
      date: 'Thursday, August 29, 2024',
      time: '',
    },
    button: {
      dataId: 'comingSoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming soon',
    },
    color: {
      background: 'linear-border-learner',
    },
    eventLink: '',
    buttonClass: '',
  },
  {
    type: 'In Person',
    location: 'Atlanta',
    title: 'Leaders and Learners',
    subtitle: 'Cross industry peer learning and networking',
    details: {
      joinUsText: 'Join Us',
      date: 'Monday, September 09, 2024',
      time: '',
    },
    button: {
      dataId: 'comingSoon',
      class:
        'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
      text: 'Coming soon',
    },
    color: {
      background: 'linear-border-learner',
    },
    eventLink: '',
    buttonClass: '',
  },
  // {
  //   'type': 'In Person',
  //   'location': 'London',
  //   'title': 'Leaders and Learners',
  //   'subtitle': 'Elevating Acquisition with Personalised Omnichannel Experiences.',
  //   'details': {
  //     'joinUsText': 'Join Us',
  //     'date': 'Xxxxxsday, Month 00, 2024',
  //     'time': '9:00 - 5:00 IST'
  //   },
  //   'button': {
  //     'dataId': 'comingSoon',
  //     'class': 'event-card-btn mb-2 spectrum-Button-utlimate has-text-grey-dark spectrum-Button spectrum-Button--cta spectrum-Button--sizeM',
  //     'text': 'Coming soon'
  //   },
  //   'color': {
  //     'background': 'linear-border-learner'
  //   },
  //   'eventLink': '',
  //   'buttonClass': ''
  // }
];

export const SUPPORTCONTACTCARDS = {
  roles: ['AE', 'CSM Name', 'TAM', 'SSM', 'TAD'],
  roleNames: {
    AE: {
      name: 'Account Executive',
      roleDescription: 'Leads account relationships and sustained partnership',
    },
    'CSM Name': {
      name: 'Customer Success Manager',
      roleDescription: ' Strategic leadership and success with entire Adobe investment',
    },
    TAM: {
      name: 'Technical Account Manager',
      roleDescription: ' Provides proactive technical leadership & insight',
    },
    SSM: {
      name: 'Support Service Manager',
      roleDescription: 'Coordinates issue resolution and case reviews.',
    },
    TAD: {
      name: 'Technical Account Director',
      roleDescription: ' Leads and oversees global technical resources to drive business outcomes',
    },
  },
};

export const SUPPORT_TICKET_UI_STATUS = {
  AUTO_CLOSED: {
    stringKey: 'AUTO_CLOSED',
    variant: 'neutral',
  },
  AWAITING_ASSIGNMENT: {
    stringKey: 'AWAITING_ASSIGNMENT',
    variant: 'info',
  },
  CANCEL_MISROUTE: {
    stringKey: 'CANCEL_MISROUTE',
    variant: 'neutral',
  },
  MEETING_SCHEDULED: {
    stringKey: 'MEETING_SCHEDULED',
    variant: 'positive',
  },
  IN_PROGRESS: {
    stringKey: 'IN_PROGRESS',
    variant: 'positive',
  },
  ISSUE_OBSOLETE: {
    stringKey: 'ISSUE_OBSOLETE',
    variant: 'neutral',
  },
  MERGED: {
    stringKey: 'MERGED',
    variant: 'neutral',
  },
  PENDING_ENGINEERING: {
    stringKey: 'IN_PROGRESS',
    variant: 'notice',
  },
  PENDING_MANAGED_SERVICES: {
    stringKey: 'IN_PROGRESS',
    variant: 'positive',
  },
  PENDING_RESPONSE: {
    stringKey: 'PENDING_RESPONSE',
    variant: 'notice',
  },
  RESOLUTION_CONFIRMED: {
    stringKey: 'RESOLUTION_CONFIRMED',
    variant: 'neutral',
  },
  RESOLUTION_IRRELEVANT: {
    stringKey: 'RESOLUTION_IRRELEVANT',
    variant: 'neutral',
  },
  RESOLUTION_PROVIDED: {
    stringKey: 'RESOLUTION_PROVIDED',
    variant: 'notice',
  },
  SESSION_COMPLETED: {
    stringKey: 'SESSION_COMPLETED',
    variant: 'neutral',
  },
  SESSION_SCHEDULED: {
    stringKey: 'SESSION_SCHEDULED',
    variant: 'positive',
  },
  UNKNOWN: {
    stringKey: 'UNKNOWN',
    variant: 'info',
  },
};

export let ECC_FIELDS_CAPP = [
  {
    id: 'ecc-support-product-accountId',
    label: 'Account ID',
    key: 'accountId',
    type: 'SHORT_TEXT'
  },
  {
    id: 'ecc-support-product-role',
    type: 'DROPDOWN',
    key: 'role',
    label: 'Role',
    title: 'Select Role',
    options: [
      {
        label: 'Admin',
        value: '5035'
      },
      {
        label: 'Author',
        value: '5036'
      },
      {
        label: 'Instructor',
        value: '5037'
      },
      {
        label: 'Manager',
        value: '5038'
      },
      {
        label: 'Learner',
        value: '5039'
      },
      {
        label: 'Integration Admin',
        value: '5040'
      }
    ]
  }
];


export let ECC_FIELDS_ADLM = [
  {
    id: 'ecc-support-product-accountId',
    label: 'Account ID',
    key: 'accountId',
    type: 'SHORT_TEXT'
  },
  {
    id: 'ecc-support-product-role',
    type: 'DROPDOWN',
    key: 'role',
    label: 'Role',
    title: 'Select Role',
    options: [
      {
        label: 'Admin',
        value: '5041'
      },
      {
        label: 'Author',
        value: '5042'
      },
      {
        label: 'Instructor',
        value: '5043'
      },
      {
        label: 'Manager',
        value: '5044'
      },
      {
        label: 'Learner',
        value: '5045'
      },
      {
        label: 'Integration Admin',
        value: '5046'
      }
    ]
  }
];

export const COMMERCE_INFRA_CHANGE = [{
  id: 'support-commerce-platform-infra-change',
  label: 'Which Infra Change you would like to do today. Choose one from below',
  title: 'Infra Change',
  options: [
    {
      label: 'Infrastructure services upgrade',
      value: '16'
    },
    {
      label: 'Cloud Project Resize (vCPU)',
      value: '15'
    },
    {
      label: 'DB Snap Shot Retrieval',
      value: '14'
    },
    {
      label: 'Service Restart',
      value: '13'
    },
    // {
    //   label: 'SSH Logs',
    //   value: '12'
    // },
    {
      label: ' Disk Storage increase request',
      value: '11'
    },
    {
      label: 'Create Read Only User',
      value: '10'
    },
    {
      label: 'Enable Autoscaling',
      value: '9'
    },
    {
      label: 'Disabling Email',
      value: '8'
    },
    {
      label: 'Domain Update',
      value: '7'
    },
    {
      label: 'Add Custom Logrotate Settings',
      value: '6'
    },
    {
      label: 'PrivateLink Setup',
      value: '5'
    },
    {
      label: 'Sendgrid Domain Authentication (Pro)',
      value: '4'
    },
    {
      label: 'Split Architecture',
      value: '3'
    },
    {
      label: 'Email Credit Reset',
      value: '2'
    },

  ]
}];

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required',
    label: 'Rabbit MQ (Required Version)',
    type: 'SHORT_TEXT',
  },
  {
    id: 'support-commerce-platform-upgrade-redis-required',
    label: 'Valkey (Required Version)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-upgrade-maria-required',
    label: 'Maria DB (Required Version)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-upgrade-open-required',
    label: 'Open Search (Required Version)',
    type: 'SHORT_TEXT'
  }
];
export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required',
    label: 'Rabbit MQ (Required Version)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-upgrade-redis-required',
    label: 'Redis (Required Version)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-upgrade-maria-required',
    label: 'Maria DB (Required Version)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-upgrade-open-required',
    label: 'Open Search (Required Version)',
    type: 'SHORT_TEXT'
  }
];
export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME = [
  {
    id: 'support-commerce-platform-upgrade-scheduled-at',
    label: 'Schedule At (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT',
    para: 'Mandatory for PROD with 48 hours notice, Non PROD environments cannot be scheduled'
  }
];

export const COMMERCE_STAGE_ENVIRONMENT_NAME = [
  {
    id: 'support-commerce-stage-environment-name',
    label: "If multiple staging environments exist, please specify the environment name. Otherwise, simply enter 'Stage'",
    type: 'SHORT_TEXT',
    placeholder: 'Please enter the stage environment name',
  }
];

export const COMMERCE_TEMPORARY_CLOUD_UPSIZE = [
  {
    id: 'support-commerce-platform-up-size-architecture',
    label: 'Select the Architecture',
    title: 'Architecture',
    options: [{
      label: 'Default Architecture',
      value: '2'
    }, {
      label: 'Scaled Architecture',
      value: '1'
    }]
  }
];
export const COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT = [
  {
    id: 'support-commerce-platform-up-size-size',
    label: 'Select the Size',
    title: 'Size',
    options: [{
      label: 'Next Available Size',
      value: '2'
    }, {
      label: 'Custom',
      value: '1'
    }]
  }
];
export const COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_CUSTOM = [
  {
    id: 'support-commerce-platform-up-size-custom',
    label: 'Custom Size',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-from-date',
    label: 'From Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-to-date',
    label: 'To Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  }
];
export const COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_NEXT = [
  {
    id: 'support-commerce-platform-up-size-from-date',
    label: 'From Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-to-date',
    label: 'To Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  }
];
export const COMMERCE_TEMPORARY_CLOUD_UPSIZE_SCALED = [

  {
    id: 'support-commerce-platform-up-size-web-node',
    label: 'Size for Web  Node',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-service-node',
    label: 'Size for Service Node',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-from-date',
    label: 'From Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-up-size-to-date',
    label: 'To Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  }
];


export const COMMERCE_DATABASE_SNAPSHOT_RETRIEVAL = [
  {
    id: 'support-commerce-platform-database-snapshot-retrieval',
    label: 'Time Period (Mention the day and time in UTC)',
    para: '<a target="_blank" id="support-commerce-platform-database-snapshot-retrieval-anchor" href="https://experienceleague.adobe.com/en/docs/commerce-on-cloud/user-guide/architecture/pro-architecture#backup-and-disaster-recovery">Refer Backup Retention Policy for the available Snapshot. In case the snap shot for the entered time period is not available, we will retrieve the closest available one.</a>',
    type: 'DATE_TIME_TEXT'
  }
];

export const COMMERCE_SERVICE_RESTART = [
  {
    id: 'support-commerce-platform-service-restart-service',
    label: 'Select the Service',
    para: 'This request can be denied if Adobe identifies services are healthy and no restart is needed',
    title: 'Service',
    options: [
      {
        label: 'Rabbit MQ',
        value: '4'
      },
      {
        label: 'Redis/Valkey',
        value: '3'
      },
      {
        label: 'Maria DB',
        value: '2'
      },
      {
        label: 'Open Search',
        value: '1'
      }
    ]
  }
];

export const COMMERCE_SSH_LOGS = [
  {
    id: 'support-commerce-platform-ssh-logs-time-period-from',
    label: 'Time Period From (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-ssh-logs-time-period-to',
    label: 'Time Period To (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  }
];

export const COMMERCE_DISK_STORAGE_INCREASE_REQUEST = [
  {
    id: 'support-commerce-platform-add-storage-current',
    label: 'Select the Storage Type',
    para: "Check your current storage -  SSH into your server and  run command  in server df -h | grep -E 'mysql|mnt|exports'",
    title: 'Storage Type',
    options: [
      {
        label: 'File System',
        value: '2'
      },
      {
        label: 'Database',
        value: '1'
      }
    ]
  },
  {
    id: 'support-commerce-platform-add-storage-size',
    label: 'Mention the size of storage to be added (min 10 GB)',
    type: 'SHORT_TEXT',
    para: '* You can increase disk space allocation by a minimum of 10 GB. Once allocated, the storage increase for Pro staging and production cannot be reverted. Storage cannot be reallocated or redistributed between resources. Check your contract before entering the value, may require extra approvals if value exceeds the contract.'
  }
];

export const COMMERCE_CREATE_READ_ONLY_USER = [
  {
    id: 'support-commerce-platform-user-creation-type',
    label: 'Select the User Type',
    title: 'User Type',
    options: [
      {
        label: 'Database User',
        value: '2'
      },
      {
        label: 'SFTP User',
        value: '1'
      }
    ]
  }
];
export const COMMERCE_CREATE_READ_ONLY_USER_DATABASE = [

  {
    id: 'support-commerce-platform-user-creation-directory',
    label: 'Desired User Name',
    type: 'SHORT_TEXT'
  }
];
export const COMMERCE_CREATE_READ_ONLY_USER_SFTP = [
  {
    id: 'support-commerce-platform-user-creation-user-name',
    label: 'Desired Directory',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-user-creation-directory',
    label: 'Desired User Name',
    type: 'SHORT_TEXT'
  }
];
export const COMMERCE_DISABLING_EMAIL = [
  {
    id: 'support-commerce-platform-disable-email-disable-date',
    label: 'Disable Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-disable-email-renable-date',
    label: 'Renable Date (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  }
];
export const COMMERCE_DOMAIN_UPDATE = [
  {
    id: 'support-commerce-platform-update-domain-list-domain',
    label: 'List of domains to be added(Comma Separated)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-update-domain-fastly-service-id',
    label: 'Fastly Service ID',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-update-domain-migration',
    label: 'Migration',
    title: 'Migration',
    options: [
      {
        label: 'Yes',
        value: '2'
      },
      {
        label: 'No',
        value: '1'
      }
    ]
  }
];

export const COMMERCE_DOMAIN_UPDATE_MIGRATION = [
  {
    id: 'support-commerce-platform-update-domain-prefered-time',
    label: 'Prefered time of update (Mention the day and time in UTC)',
    type: 'DATE_TIME_TEXT'
  },
  {
    id: 'support-commerce-platform-update-domain-source-destination',
    label: 'Source and Destination Project IDs along with Fastly service IDs',
    type: 'SHORT_TEXT'
  }
];

export const COMMERCE_ADD_CUSTOM_LOGRATE_SETTING = [
  {
    id: 'support-commerce-platform-custom-lograte-full-path',
    label: 'Full path to logs requiring rotation',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-custom-lograte-retention-period',
    label: 'Retention period (default 365)',
    type: 'SHORT_TEXT'
  }
];
export const COMMERCE_PRIVATE_LINK_SETUP = [
  {
    id: 'support-commerce-platform-private-link-cloud-type',
    label: 'Private Link Cloud Type',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-aws-account',
    label: 'Private Link AWS/Azure Account Number',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-environment',
    label: 'Private Link Environment',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-setup',
    label: 'Private Link Setup Type',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-connection-type',
    label: 'Private Link Connection Type',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-communication-port',
    label: 'Private Link Services + Communication Ports',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-service-endpoint',
    label: 'Private Link Service Endpoint',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-private-link-staging-server-name',
    label: 'Private Link Staging Server Name',
    type: 'SHORT_TEXT'
  }
];


export const COMMERCE_SEND_GRID_DOMAIN_AUTHENTICATION = [
  {
    id: 'support-commerce-platform-send-grid-email',
    label: "Sender's email address used by the application to send emails from",
    type: 'SHORT_TEXT'
  }
];

export const COMMERCE_SPLIT_ARCHITECTURE = [
  {
    id: 'support-commerce-platform-split-architecture-core-sizing',
    label: 'Core Sizing',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-split-architecture-web-cores',
    label: 'Web Cores(total number of vCPUs)',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-split-architecture-web-node-count',
    label: 'Web Node Count',
    type: 'SHORT_TEXT'
  },
  {
    id: 'support-commerce-platform-split-architecture-auto-scaling',
    label: 'Active Autoscaling',
    title: 'Active Autoscaling',
    options: [
      {
        label: 'Yes',
        value: '2'
      },
      {
        label: 'No',
        value: '1'
      }
    ]
  }
];

export const COMMERCE_ADDITIONAL_FIELD_LABEL = {
  'Environment': 'What environment is affected?',
  'Stage Environment Name': 'Stage Environment Name',
  'Project ID': 'What project is affected?',
  'Which Infra Change you would like to do today. Choose one from below': 'What is the issue or change request?',
  'Time Period (Mention the day and time in UTC)': 'Time Period (Mention the day and time in UTC)',
  'Active Autoscaling': 'Autoscaling',
  'Retention period (default 365)': 'Retention period',
  "Sender's email address used by the application to send emails from": 'Email Domain to configure',
  'Schedule at': 'Schedule Date/ Time',
  'Size for Web  Node': 'Target Size For Webnode',
  'Size for Service Node': 'Target Size for Service Node',
  'Time Period From (Mention the day and time in UTC)': 'From Date (Mention the day and time in UTC)',
  'Time Period To (Mention the day and time in UTC)': 'To Date (Mention the day and time in UTC)',
  'Select the Service': '',
  'Select the Storage Type': 'Where to allocate storage',
  'Mention the size of storage to be added (min 10 GB)': 'Amount to add in GB',
  'Desired Directory': 'Chroot path',
  'Select the User Type': 'User Type',
  'Renable Date (Mention the day and time in UTC)': 'When to re-enable email date + time in UTC (YYYY-MM-DD format)',
  'Disable Date (Mention the day and time in UTC)': 'When to disable email date + time in UTC (YYYY-MM-DD format)',
  'Web Cores(total number of vCPUs)': 'Web Cores',
  'Core Sizing': 'Unified Sizing',
  'Select the Architecture': 'Type of Architecture'
};

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_4 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [{
      label: '3.9',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-redis-required-dropdown',
    label: 'Redis (Required Version)',
    title: 'Redis Version',
    options: [{
      label: '6.2',
      value: '3'
    }, {
      label: '7.0',
      value: '2'
    }, {
      label: '7.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-maria-required-dropdown',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '10.4',
      value: '3'
    }, {
      label: '10.5',
      value: '2'
    }, {
      label: '10.6',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-open-required-dropdown',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '1',
      value: '2'
    }, {
      label: '2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
];

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_5 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required-dropdown',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [
    {
      label: '3.9',
      value: '6'
    }, {
      label: '3.11',
      value: '5'
    }, {
      label: '3.12',
      value: '4'
    }, {
      label: '3.13',
      value: '3'
    }, {
      label: '4.1',
      value: '2'
    }, {
      label: '4.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-redis-required-dropdown',
    label: 'Redis/Valkey (Required Version)',
    title: 'Redis/Valkey Version',
    options: [{
      label: '6.2',
      value: '5'
    }, {
      label: '7.0',
      value: '4'
    }, {
      label: '7.2',
      value: '3'
    }, {
      label: '8',
      value: '2'
    }, {
      label: '8.1',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-maria-required-dropdown',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '10.4',
      value: '4'
    }, {
      label: '10.5',
      value: '3'
    }, {
      label: '10.6',
      value: '2'
    }, {
      label: '10.11',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-open-required-dropdown',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '1',
      value: '2'
    }, {
      label: '2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
];

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_6 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required-dropdown',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [{
      label: '3.9',
      value: '6'
    }, {
      label: '3.11',
      value: '5'
    }, {
      label: '3.12',
      value: '4'
    }, {
      label: '3.13',
      value: '3'
    }, {
      label: '4.1',
      value: '2'
    }, {
      label: '4.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-redis-required-dropdown',
    label: 'Redis/Valkey (Required Version)',
    title: 'Redis/Valkey Version',
    options: [{
      label: '7.0',
      value: '4'
    }, {
      label: '7.2',
      value: '3'
    }, {
      label: '8',
      value: '2'
    }, {
      label: '8.1',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-maria-required-dropdown',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '10.6',
      value: '2'
    }, {
      label: '10.11',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-open-required',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '2',
      value: '2'
    }, {
      label: '3',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]
  },
];

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_7 = [
   {
    id: 'support-commerce-platform-upgrade-rabbit-required-dropdown',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [{
      label: '3.12',
      value: '4'
    }, {
      label: '3.13',
      value: '3'
    }, {
      label: '4.1',
      value: '2'
    }, {
      label: '4.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-redis-required-dropdown',
    label: 'Redis/Valkey (Required Version)',
    title: 'Redis/Valkey',
    options: [{
      label: '7.2',
      value: '3'
    }, {
      label: '8',
      value: '2'
    }, {
      label: '8.1',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-maria-required-dropdown',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '10.6',
      value: '3'
    }, {
      label: '10.11',
      value: '2'
    }, {
      label: '11.8',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  },
  {
    id: 'support-commerce-platform-upgrade-open-required',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '2',
      value: '2'
    }, {
      label: '3',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
];

export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [{
      label: '4.1',
      value: '2'
    }, {
      label: '4.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-redis-required',
    label: 'Valkey (Required Version)',
    title: 'Valkey Version',
    options: [{
      label: '8',
      value: '2'
    }, {
      label: '8.1',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-maria-required',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '11.4',
      value: '2'
    }, {
      label: '11.8',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-open-required-dropdown',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '2',
      value: '2'
    }, {
      label: '3',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
];
export const COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_9 = [
  {
    id: 'support-commerce-platform-upgrade-rabbit-required',
    label: 'Rabbit MQ (Required Version)',
    title: 'Rabbit MQ Version',
    options: [{
      label: '4.2',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-redis-required',
    label: 'Valkey (Required Version)',
    title: 'Valkey Version',
    options: [{
      label: '9',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-maria-required',
    label: 'Maria DB (Required Version)',
    title: 'Maria DB Version',
    options: [{
      label: '12.3',
      value: '2'
    }, {
      label: '11.8',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
  {
    id: 'support-commerce-platform-upgrade-open-required-dropdown',
    label: 'Open Search (Required Version)',
    title: 'Open Search Version',
    options: [{
      label: '3',
      value: '1'
    }, {
      label: 'N/A',
      value: '0'
    }]  
  },
];

export const SERVICES_VERSION = {
    'Alpha/Beta':{
        'Rabbit MQ':'4.1',
        'Valkey':'8',
        'Maria DB':'11.4',
        'Open Search':'2',
    },
    '2.4.8':{
        'Rabbit MQ':'4.1',
        'Valkey':'8',
        'Maria DB':'11.4',
        'Open Search':'2',
    },
    '2.4.7':{
        'Rabbit MQ':'3.12',
        'Valkey':'7.2',
        'Maria DB':'10.6',
        'Open Search':'2',
    },
    '2.4.6':{
        'Rabbit MQ':' ',
        'Valkey':'7.0',
        'Maria DB':'10.6',
        'Open Search':'2',
    },
    '2.4.5':{
        'Rabbit MQ':'3.9',
        'Valkey':'6.2',
        'Maria DB':'10.4',
        'Open Search':'1',
    },
    '2.4.4 and older (unsupported)':{
        'Rabbit MQ':'3.9',
        'Valkey':'6.2',
        'Maria DB':'10.4',
        'Open Search':'1',
    }
}

export const COMMON_FIELDS = [
  {
    id: 'support-openticket-casedescription',
    label: 'Please describe the issue',
    sublabel: 'Add at least 50 characters to generate recommendations',
    key: 'caseDescription',
    type: 'LONG_TEXT',
    textAreaId: 'support-openticket-casedescription-input',
    placeholder:'Please describe the issue'
  },
  {
    id: 'support-openticket-casetitle',
    label: 'Case Title',
    sublabel: 'Title will be generated automatically. You can edit it anytime',
    key: 'caseTitle',
    type: 'SHORT_TEXT',
    textAreaId: 'support-openticket-casetitle-input',
    placeholder:'Generated from your description. Edit if needed.'
  },
  {
    id: 'steps-to-reproduce',
    label: 'Is this issue reproducible?',
    key: 'stepsToReproduce',
    type: 'RADIO',
    showSuggestionForOption: 'yes',
    textAreaId: 'steps-to-reproduce-input',
    suggestionLabel:'Please provide the steps taken to reproduce this issue',
    suggestionPlaceholder:'Please provide the steps taken to reproduce this issue',
    suggestionRequired: true,
    required: true,
    options: [
      {
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }
    ]
  }
]


export const DESCRIPTION_FIELDS = {
  "mkto_support": [
    {
      id: 'munchkinId',
      label: 'Munchkin ID',
      key: 'munchkinId',
      type: 'SHORT_TEXT',
      textAreaId: 'munchkinId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_target_support": [
    {
      id: 'activityName',
      label: 'Activity Name',
      key: 'activityName',
      type: 'SHORT_TEXT',
      textAreaId: 'activityName-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'siteUrl',
      label: 'Site URL(Tags Property Name)',
      key: 'siteUrl',
      type: 'SHORT_TEXT',
      textAreaId: 'siteUrl-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_analytics_support": [
    {
      id: 'rsid',
      label: 'RSID',
      key: 'rsid',
      type: 'SHORT_TEXT',
      textAreaId: 'rsid-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'siteUrl',
      label: 'Site URL(Tags Property Name)/cURL',
      key: 'siteUrl',
      type: 'SHORT_TEXT',
      textAreaId: 'siteUrl-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'workspaceShortlink',
      label: 'Workspace Shortlink',
      key: 'workspaceShortlink',
      type: 'SHORT_TEXT',
      textAreaId: 'workspaceShortlink-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },


  ],
  "dx_journeys_support": [
    {
      id: 'journeyId',
      label: 'Journey ID or URL/Campaign ID or URL/Channel ID or URL/Offer Decisioning ID or URL',
      key: 'journeyId',
      type: 'SHORT_TEXT',
      textAreaId: 'journeyId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'exampleProfile',
      label: 'Example profile',
      key: 'exampleProfile',
      type: 'SHORT_TEXT',
      textAreaId: 'exampleProfile-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_ajo_btob_support": [
    {
      id: 'journeyId',
      label: 'Journey ID or URL/Campaign ID URL',
      key: 'journeyId',
      type: 'SHORT_TEXT',
      textAreaId: 'journeyId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'buyingGroupId',
      label: 'Account ID/Buying Group ID/Lead ID',
      key: 'buyingGroupId',
      type: 'SHORT_TEXT',
      textAreaId: 'buyingGroupId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_cjm_support": [
    {
      id: 'journeyId',
      label: 'Journey ID or URL/Campaign ID or URL/Channel ID or URL/Offer Decisioning ID or URL',
      key: 'journeyId',
      type: 'SHORT_TEXT',
      textAreaId: 'journeyId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'exampleProfile',
      label: 'Example profile',
      key: 'exampleProfile',
      type: 'SHORT_TEXT',
      textAreaId: 'exampleProfile-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_offers_support": [
    {
      id: 'journeyId',
      label: 'Journey ID or URL/Campaign ID or URL/Channel ID or URL/Offer Decisioning ID or URL',
      key: 'journeyId',
      type: 'SHORT_TEXT',
      textAreaId: 'journeyId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'exampleProfile',
      label: 'Example profile',
      key: 'exampleProfile',
      type: 'SHORT_TEXT',
      textAreaId: 'exampleProfile-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_rt_cdp_support": [
    {
      id: 'affectedComponent',
      label: 'Affected Component ID (Destination ID/Audience ID/Dataset ID/Dataflow ID/Merge Policy ID/Schema ID/Source ID/Batch ID)',
      key: 'affectedComponent',
      type: 'SHORT_TEXT',
      textAreaId: 'affectedComponent-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'exampleProfile',
      label: 'Example profile',
      key: 'exampleProfile',
      type: 'SHORT_TEXT',
      textAreaId: 'exampleProfile-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_aep_support": [
    {
      id: 'affectedComponent',
      label: 'Affected Component ID (Destination ID/Audience ID/Dataset ID/Dataflow ID/Merge Policy ID/Schema ID/Source ID/Batch ID)',
      key: 'affectedComponent',
      type: 'SHORT_TEXT',
      textAreaId: 'affectedComponent-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'exampleProfile',
      label: 'Example profile',
      key: 'exampleProfile',
      type: 'SHORT_TEXT',
      textAreaId: 'exampleProfile-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    // {
    //   id: 'asssuranceLogs',
    //   label: 'HAR File / Assurance Logs',
    //   key: 'asssuranceLogs',
    //   type: 'SHORT_TEXT',
    //   textAreaId: 'asssuranceLogs-input',
    //   placeholder: '',
    //   textAreaClass: 'add-in-description'
    // },
    {
      id: 'sandboxName',
      label: 'Sandbox Name',
      key: 'sandboxName', 
      type: 'SHORT_TEXT',
      textAreaId: 'sandbox-name-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_customer_journey_analytics_support": [
    {
      id: 'workspaceProject',
      label: 'Workspace project URL',
      key: 'workspaceProject',
      type: 'SHORT_TEXT',
      textAreaId: 'workspaceProject-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'connectionId',
      label: 'Connection ID / Error message / Code',
      key: 'connectionId',
      type: 'SHORT_TEXT',
      textAreaId: 'connectionId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    },
    {
      id: 'dataViewId',
      label: 'Data View ID',
      key: 'dataViewId',
      type: 'SHORT_TEXT',
      textAreaId: 'dataViewId-input',
      placeholder: '',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_commercecloud_support": [
    {
      id: 'additionalInfo',
      label: 'Additional information (Type NA if nothing is needed)',
      key: 'additionalInfo',
      type: 'SHORT_TEXT',
      textAreaId: 'additionalInfo-input',
      placeholder: 'Please enter additional details for this change eg:- environment is stage1/2 etc, or any other info.',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_commerceonprem_support": [
    {
      id: 'additionalInfo',
      label: 'Additional information (Type NA if nothing is needed)',
      key: 'additionalInfo',
      type: 'SHORT_TEXT',
      textAreaId: 'additionalInfo-input',
      placeholder: 'Please enter additional details for this change eg:- environment is stage1/2 etc, or any other info.',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_commercepaymentservices_support": [
    {
      id: 'additionalInfo',
      label: 'Additional information (Type NA if nothing is needed)',
      key: 'additionalInfo',
      type: 'SHORT_TEXT',
      textAreaId: 'additionalInfo-input',
      placeholder: 'Please enter additional details for this change eg:- environment is stage1/2 etc, or any other info.',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_commercereporting_support": [
    {
      id: 'additionalInfo',
      label: 'Additional information (Type NA if nothing is needed)',
      key: 'additionalInfo',
      type: 'SHORT_TEXT',
      textAreaId: 'additionalInfo-input',
      placeholder: 'Please enter additional details for this change eg:- environment is stage1/2 etc, or any other info.',
      textAreaClass: 'add-in-description'
    }
  ],
  "dx_commercemanagedservices_support": [
    {
      id: 'additionalInfo',
      label: 'Additional information (Type NA if nothing is needed)',
      key: 'additionalInfo',
      type: 'SHORT_TEXT',
      textAreaId: 'additionalInfo-input',
      placeholder: 'Please enter additional details for this change eg:- environment is stage1/2 etc, or any other info.',
      textAreaClass: 'add-in-description'
    }
  ],
}

export const ENVIRONMENT_FIELD =   [{
    id: 'env-description-field',
    label: 'Have there been any recent changes to the environment?',
    key: 'environmentChanges',
    type: 'RADIO',
    showSuggestionForOption: 'yes',
    textAreaId: 'environmentChanges-input',
    suggestionLabel:'Please describe any recent changes to the environment.',
    suggestionPlaceholder:'Please describe any recent changes to the environment.',
    suggestionRequired: true,
    required: true,
    options: [
      {
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }
    ]
  }]

export const priorityKeys = {  
  '4': 'P4- Minor',
  '3': 'P3- Important',
  '2': 'P2- Urgent',
  '1': 'P1- Critical',
};
export const workfrontPriorityKeys = {  
  'Low': 'P4- Minor',
  'Medium': 'P3- Important',
  'High': 'P2- Urgent',
  'Critical': 'P1- Critical',
};

export const impactKeys = {
  '3': 'Small',     
  '2': 'Medium',
  '1': 'Large',
}
export const productToFamilyMapping = {
  dx_aem_ams_support: "AEM",
  dx_acwp_support: "Campaign",
  dx_aem_assets_support: "AEM",
  dx_aem_fcs_support: "AEM",
  dx_aem_sites_support: "AEM",
  dx_aod_support: "AEM",
  dx_brand_portal_support: "AEM",
  dx_campaign_classic_support: "Campaign",
  dx_campaign_mgd_support: "Campaign",
  dx_campaign_support: "Campaign",
  dx_campaign_v_6_support: "Campaign",
  dx_offers_support: "AEP",
  dx_rt_cdp_support: "AEP",
  dx_scene_7_support: "AEM",
  dx_genstudio_support: "GenStudio",
  mkto_support: "Marketo",
  amm_support: "Marketo",
  dx_aep_support: "AEP",
  dx_customer_journey_analytics_support: "AEP",
  dx_aem_perf_support: "AEM",
  dx_cjm_support: "AEP",
  dx_journeys_support: "AEP",
  dx_aem_onprem: "AEM",
  dx_campaign_onprem: "Campaign",
  dx_commercecloud_support: "Commerce",
  dx_commerceonprem_support: "Commerce",
  dx_commercereporting_support: "Commerce",
  dx_commercemanagedservices_support: "Commerce",
  dx_commerceordermanagement_support: "Commerce",
  dx_commercepaymentservices_support: "Commerce",
  dx_commercestorefulfillment_support: "Commerce",
  dx_a_commerce_cloudsrvc_support: "Commerce",
  dx_a_commerce_aco_support: "Commerce",
  dx_a_commerce_cloudsrvc_ms_support: "Commerce",
  dx_genstudio_foundation_support: "GenStudio"
};

export const peopleForSmokeTesting = [
  {name: 'Prashant Khulbe', email: 'pkhulbe@adobe.com'},
  {name: 'George Varghese', email: 'gvarghes@adobe.com'},
  {name: 'Matthew Johnson', email: 'majohnso@adobe.com'},
  {name: 'Yoadan Abebe', email: 'yabebe@adobe.com'},
  {name: 'Brittany Garrison', email: 'bgarrison@adobe.com'},
  {name: 'Lauren Kastens', email: 'schutte@adobe.com'},
  {name: 'Karthigeyan N', email: 'karthr@adobe.com'},
  {name: 'Aarzoo Kapoor', email: 'aakapoor@adobe.com'},
  {name: 'Pooja Panwar', email: 'glo16533@adobe.com'},
  {name: 'Oleksandr Karpenko', email: 'karpenko@adobe.com'},
  {name: 'Aditi Patwardhan', email: 'apatwardhan@adobe.com'},
  {name: 'Brad Littler', email: 'littler@adobe.com'},
  {name: 'Vladyslav Scherbyna', email: 'shcherby@adobe.com'},
  {name: 'Sanjana Sagi', email: 'sagi@adobe.com'},
  {name: 'Rajkumar Shinde', email: 'rajkumarshin@adobe.com'},
  {name: 'Yin Glezos', email: 'glezos@adobe.com'},
  {name: 'Chelsi Kroff', email: 'ckroff@adobe.com'},
  {name: 'Anandkar Upadhyay', email: 'glo18783@adobe.com'},
  {name: 'Debasish Gogoi', email: 'glo43611@adobe.com'},
  {name: 'Jamuna Prasad', email: 'glo42778@adobe.com'},
  {name: 'Jagdish Thakre', email: 'glo53848@adobe.com'},
  {name: 'Rahul Kumar', email: 'glo53350@adobe.com'},
  {name: 'Amitesh Srivastava', email: 'glo54121@adobe.com'},
  {name: 'Mayank Gupta', email: 'gra61007@adobe.com'},
  {name: 'Prakhar Sambhav', email: 'gra00184@adobe.com'},
  {name: 'Yarik Voronyi', email: 'yvoronoy@adobe.com'},
  {name: 'Sathya Chinnalagu', email: 'chinnala@adobe.com'},
  { name: 'Venu Madhuri Addala', email: 'vaddala@adobe.com'},
  {name: 'Tomonori Hasegawa', email: 'thasegaw@adobe.com'},
  { name: 'test Account', email: 'yadavpur+US+Free+VISA+Type1+1@adobetest.com'},
  { name: 'Sathish Purushothaman', email: 'sof67623@adobe.com'},
  { name: 'Stacy Kummer', email: 'sof13733@adobe.com'},
  { name: 'Abhishek', email: 'sof16167@adobe.com'},
  { name: 'Kaif', email: 'sof01402@adobe.com'},
  { name: 'Jeff Marques', email: 'jeffmar@adobe.com' },
  { name: 'Vladimir', email: 'alp25176@adobe.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+en@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+fr@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+de@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+jp@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+es@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+ptb@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+it@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+cn@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+tw@adobetest.com' },
  { name: 'alp27135', email: 'alp27135+exl+prod+ko@adobetest.com' },
]

export const communityProductMapping = [
  { productCode: "dx_aem_ams_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_acwp_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  { productCode: "dx_aem_assets_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_aem_fcs_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_aem_sites_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_analytics_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-analytics-3" 
  },
  { productCode: "dx_aod_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_audience_manager_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-audience-manager-16" 
  },
  { productCode: "dx_brand_portal_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_campaign_classic_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  { productCode: "dx_campaign_mgd_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  { productCode: "dx_campaign_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  { productCode: "dx_campaign_v_6_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  { productCode: "dx_offers_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-platform-18" 
  },
  { productCode: "dx_rt_cdp_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-real-time-customer-data-platform-25" 
  },
  { productCode: "dx_scene_7_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_target_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-target-14" 
  },
  { productCode: "dx_genstudio_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "mkto_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-marketo-engage-26" 
  },
  { productCode: "amm_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-marketo-engage-26" 
  },
  { productCode: "dx_aep_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-platform-18" 
  },
  { productCode: "dx_ajo_btob_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15" 
  },
  { productCode: "dx_customer_journey_analytics_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-platform-18" 
  },
  { productCode: "dx_aem_perf_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  // { productCode: "dx_mix_modeler_support",
  //   link: "" 
  // },
  { productCode: "dx_cjm_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-journey-optimizer-15" 
  },
  { productCode: "dx_journeys_support",
    link: "https://experienceleaguecommunities.adobe.com/adobe-experience-platform-18" 
  },
  { productCode: "dx_aem_onprem",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  { productCode: "dx_campaign_onprem",
    link: "https://experienceleaguecommunities.adobe.com/adobe-campaign-4" 
  },
  // { productCode: "dx_commercecloud_support",
  //   link: "" 
  // },
  // { productCode: "dx_commerceonprem_support",
  //   link: "" 
  // },
  // { productCode: "dx_commercereporting_support",
  //   link: "" 
  // },
  // { productCode: "dx_commercemanagedservices_support",
  //   link: "" 
  // },
  // { productCode: "dx_commerceordermanagement_support",
  //   link: "" 
  // },
  // { productCode: "dx_commercepaymentservices_support",
  //   link: "" 
  // },
  // { productCode: "dx_commercestorefulfillment_support",
  //   link: "" 
  // },
  // { productCode: "dx_a_commerce_cloudsrvc_support",
  //   link: "" 
  // },
  // { productCode: "dx_a_commerce_aco_support",
  //   link: "" 
  // },
  // { productCode: "dx_a_commerce_cloudsrvc_ms_support",
  //   link: "" 
  // },
  { productCode: "dx_genstudio_foundation_support",
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  // { productCode: "dx_bc_support",
  //   link: "" 
  // },
  { productCode: "dx_llmo_support", 
    link: "http://experienceleaguecommunities.adobe.com/adobe-experience-manager-7" 
  },
  {
    productCode: 'dx_workfront_fusion_support',
    link: "https://experienceleaguecommunities.adobe.com/adobe-workfront-22",
  },
  {
    productCode: 'dx_workfront_support',
    link: "https://experienceleaguecommunities.adobe.com/adobe-workfront-22",
  },
  // {
  //   productCode: 'ADLM',
  //   link: "https://experienceleaguecommunities.adobe.com",
  // },
  // {
  //   productCode: 'CAPP',
  //   link: "https://experienceleaguecommunities.adobe.com",
  // },
  {
    productCode: 'dx_advertising_search_support',
    link: "https://experienceleaguecommunities.adobe.com/adobe-advertising-2",
  },
  {
    productCode: 'dx_advertising_dsp_support',
    link: "https://experienceleaguecommunities.adobe.com/adobe-advertising-2",
  },
  // {
  //   productCode: 'dx_ajo_btob_support',
  //   link: "https://experienceleaguecommunities.adobe.com",
  // }
];

export const COUNTRY_CALLING_CODES = [
  { iso2: 'AF', name: 'Afghanistan', dialCode: '93' },
  { iso2: 'AL', name: 'Albania', dialCode: '355' },
  { iso2: 'DZ', name: 'Algeria', dialCode: '213' },
  { iso2: 'AS', name: 'American Samoa', dialCode: '1' },
  { iso2: 'AD', name: 'Andorra', dialCode: '376' },
  { iso2: 'AO', name: 'Angola', dialCode: '244' },
  { iso2: 'AI', name: 'Anguilla', dialCode: '1' },
  { iso2: 'AG', name: 'Antigua and Barbuda', dialCode: '1' },
  { iso2: 'AR', name: 'Argentina', dialCode: '54' },
  { iso2: 'AM', name: 'Armenia', dialCode: '374' },
  { iso2: 'AW', name: 'Aruba', dialCode: '297' },
  { iso2: 'AU', name: 'Australia', dialCode: '61' },
  { iso2: 'AT', name: 'Austria', dialCode: '43' },
  { iso2: 'AZ', name: 'Azerbaijan', dialCode: '994' },
  { iso2: 'BS', name: 'Bahamas', dialCode: '1' },
  { iso2: 'BH', name: 'Bahrain', dialCode: '973' },
  { iso2: 'BD', name: 'Bangladesh', dialCode: '880' },
  { iso2: 'BB', name: 'Barbados', dialCode: '1' },
  { iso2: 'BY', name: 'Belarus', dialCode: '375' },
  { iso2: 'BE', name: 'Belgium', dialCode: '32' },
  { iso2: 'BZ', name: 'Belize', dialCode: '501' },
  { iso2: 'BJ', name: 'Benin', dialCode: '229' },
  { iso2: 'BM', name: 'Bermuda', dialCode: '1' },
  { iso2: 'BT', name: 'Bhutan', dialCode: '975' },
  { iso2: 'BO', name: 'Bolivia', dialCode: '591' },
  { iso2: 'BA', name: 'Bosnia and Herzegovina', dialCode: '387' },
  { iso2: 'BW', name: 'Botswana', dialCode: '267' },
  { iso2: 'BR', name: 'Brazil', dialCode: '55' },
  { iso2: 'BN', name: 'Brunei', dialCode: '673' },
  { iso2: 'BG', name: 'Bulgaria', dialCode: '359' },
  { iso2: 'BF', name: 'Burkina Faso', dialCode: '226' },
  { iso2: 'BI', name: 'Burundi', dialCode: '257' },
  { iso2: 'KH', name: 'Cambodia', dialCode: '855' },
  { iso2: 'CM', name: 'Cameroon', dialCode: '237' },
  { iso2: 'CA', name: 'Canada', dialCode: '1' },
  { iso2: 'CV', name: 'Cape Verde', dialCode: '238' },
  { iso2: 'KY', name: 'Cayman Islands', dialCode: '1' },
  { iso2: 'CF', name: 'Central African Republic', dialCode: '236' },
  { iso2: 'TD', name: 'Chad', dialCode: '235' },
  { iso2: 'CL', name: 'Chile', dialCode: '56' },
  { iso2: 'CN', name: 'China', dialCode: '86' },
  { iso2: 'CO', name: 'Colombia', dialCode: '57' },
  { iso2: 'KM', name: 'Comoros', dialCode: '269' },
  { iso2: 'CG', name: 'Congo', dialCode: '242' },
  { iso2: 'CD', name: 'Congo (DRC)', dialCode: '243' },
  { iso2: 'CR', name: 'Costa Rica', dialCode: '506' },
  { iso2: 'CI', name: "Cote d'Ivoire", dialCode: '225' },
  { iso2: 'HR', name: 'Croatia', dialCode: '385' },
  { iso2: 'CU', name: 'Cuba', dialCode: '53' },
  { iso2: 'CY', name: 'Cyprus', dialCode: '357' },
  { iso2: 'CZ', name: 'Czech Republic', dialCode: '420' },
  { iso2: 'DK', name: 'Denmark', dialCode: '45' },
  { iso2: 'DJ', name: 'Djibouti', dialCode: '253' },
  { iso2: 'DM', name: 'Dominica', dialCode: '1' },
  { iso2: 'DO', name: 'Dominican Republic', dialCode: '1' },
  { iso2: 'EC', name: 'Ecuador', dialCode: '593' },
  { iso2: 'EG', name: 'Egypt', dialCode: '20' },
  { iso2: 'SV', name: 'El Salvador', dialCode: '503' },
  { iso2: 'GQ', name: 'Equatorial Guinea', dialCode: '240' },
  { iso2: 'ER', name: 'Eritrea', dialCode: '291' },
  { iso2: 'EE', name: 'Estonia', dialCode: '372' },
  { iso2: 'SZ', name: 'Eswatini', dialCode: '268' },
  { iso2: 'ET', name: 'Ethiopia', dialCode: '251' },
  { iso2: 'FJ', name: 'Fiji', dialCode: '679' },
  { iso2: 'FI', name: 'Finland', dialCode: '358' },
  { iso2: 'FR', name: 'France', dialCode: '33' },
  { iso2: 'GF', name: 'French Guiana', dialCode: '594' },
  { iso2: 'PF', name: 'French Polynesia', dialCode: '689' },
  { iso2: 'GA', name: 'Gabon', dialCode: '241' },
  { iso2: 'GM', name: 'Gambia', dialCode: '220' },
  { iso2: 'GE', name: 'Georgia', dialCode: '995' },
  { iso2: 'DE', name: 'Germany', dialCode: '49' },
  { iso2: 'GH', name: 'Ghana', dialCode: '233' },
  { iso2: 'GI', name: 'Gibraltar', dialCode: '350' },
  { iso2: 'GR', name: 'Greece', dialCode: '30' },
  { iso2: 'GL', name: 'Greenland', dialCode: '299' },
  { iso2: 'GD', name: 'Grenada', dialCode: '1' },
  { iso2: 'GP', name: 'Guadeloupe', dialCode: '590' },
  { iso2: 'GU', name: 'Guam', dialCode: '1' },
  { iso2: 'GT', name: 'Guatemala', dialCode: '502' },
  { iso2: 'GN', name: 'Guinea', dialCode: '224' },
  { iso2: 'GW', name: 'Guinea-Bissau', dialCode: '245' },
  { iso2: 'GY', name: 'Guyana', dialCode: '592' },
  { iso2: 'HT', name: 'Haiti', dialCode: '509' },
  { iso2: 'HN', name: 'Honduras', dialCode: '504' },
  { iso2: 'HK', name: 'Hong Kong', dialCode: '852' },
  { iso2: 'HU', name: 'Hungary', dialCode: '36' },
  { iso2: 'IS', name: 'Iceland', dialCode: '354' },
  { iso2: 'IN', name: 'India', dialCode: '91' },
  { iso2: 'ID', name: 'Indonesia', dialCode: '62' },
  { iso2: 'IR', name: 'Iran', dialCode: '98' },
  { iso2: 'IQ', name: 'Iraq', dialCode: '964' },
  { iso2: 'IE', name: 'Ireland', dialCode: '353' },
  { iso2: 'IL', name: 'Israel', dialCode: '972' },
  { iso2: 'IT', name: 'Italy', dialCode: '39' },
  { iso2: 'JM', name: 'Jamaica', dialCode: '1' },
  { iso2: 'JP', name: 'Japan', dialCode: '81' },
  { iso2: 'JO', name: 'Jordan', dialCode: '962' },
  { iso2: 'KZ', name: 'Kazakhstan', dialCode: '7' },
  { iso2: 'KE', name: 'Kenya', dialCode: '254' },
  { iso2: 'KI', name: 'Kiribati', dialCode: '686' },
  { iso2: 'KW', name: 'Kuwait', dialCode: '965' },
  { iso2: 'KG', name: 'Kyrgyzstan', dialCode: '996' },
  { iso2: 'LA', name: 'Laos', dialCode: '856' },
  { iso2: 'LV', name: 'Latvia', dialCode: '371' },
  { iso2: 'LB', name: 'Lebanon', dialCode: '961' },
  { iso2: 'LS', name: 'Lesotho', dialCode: '266' },
  { iso2: 'LR', name: 'Liberia', dialCode: '231' },
  { iso2: 'LY', name: 'Libya', dialCode: '218' },
  { iso2: 'LI', name: 'Liechtenstein', dialCode: '423' },
  { iso2: 'LT', name: 'Lithuania', dialCode: '370' },
  { iso2: 'LU', name: 'Luxembourg', dialCode: '352' },
  { iso2: 'MO', name: 'Macau', dialCode: '853' },
  { iso2: 'MG', name: 'Madagascar', dialCode: '261' },
  { iso2: 'MW', name: 'Malawi', dialCode: '265' },
  { iso2: 'MY', name: 'Malaysia', dialCode: '60' },
  { iso2: 'MV', name: 'Maldives', dialCode: '960' },
  { iso2: 'ML', name: 'Mali', dialCode: '223' },
  { iso2: 'MT', name: 'Malta', dialCode: '356' },
  { iso2: 'MH', name: 'Marshall Islands', dialCode: '692' },
  { iso2: 'MQ', name: 'Martinique', dialCode: '596' },
  { iso2: 'MR', name: 'Mauritania', dialCode: '222' },
  { iso2: 'MU', name: 'Mauritius', dialCode: '230' },
  { iso2: 'MX', name: 'Mexico', dialCode: '52' },
  { iso2: 'FM', name: 'Micronesia', dialCode: '691' },
  { iso2: 'MD', name: 'Moldova', dialCode: '373' },
  { iso2: 'MC', name: 'Monaco', dialCode: '377' },
  { iso2: 'MN', name: 'Mongolia', dialCode: '976' },
  { iso2: 'ME', name: 'Montenegro', dialCode: '382' },
  { iso2: 'MS', name: 'Montserrat', dialCode: '1' },
  { iso2: 'MA', name: 'Morocco', dialCode: '212' },
  { iso2: 'MZ', name: 'Mozambique', dialCode: '258' },
  { iso2: 'MM', name: 'Myanmar', dialCode: '95' },
  { iso2: 'NA', name: 'Namibia', dialCode: '264' },
  { iso2: 'NR', name: 'Nauru', dialCode: '674' },
  { iso2: 'NP', name: 'Nepal', dialCode: '977' },
  { iso2: 'NL', name: 'Netherlands', dialCode: '31' },
  { iso2: 'NC', name: 'New Caledonia', dialCode: '687' },
  { iso2: 'NZ', name: 'New Zealand', dialCode: '64' },
  { iso2: 'NI', name: 'Nicaragua', dialCode: '505' },
  { iso2: 'NE', name: 'Niger', dialCode: '227' },
  { iso2: 'NG', name: 'Nigeria', dialCode: '234' },
  { iso2: 'MK', name: 'North Macedonia', dialCode: '389' },
  { iso2: 'NO', name: 'Norway', dialCode: '47' },
  { iso2: 'OM', name: 'Oman', dialCode: '968' },
  { iso2: 'PK', name: 'Pakistan', dialCode: '92' },
  { iso2: 'PW', name: 'Palau', dialCode: '680' },
  { iso2: 'PS', name: 'Palestine', dialCode: '970' },
  { iso2: 'PA', name: 'Panama', dialCode: '507' },
  { iso2: 'PG', name: 'Papua New Guinea', dialCode: '675' },
  { iso2: 'PY', name: 'Paraguay', dialCode: '595' },
  { iso2: 'PE', name: 'Peru', dialCode: '51' },
  { iso2: 'PH', name: 'Philippines', dialCode: '63' },
  { iso2: 'PL', name: 'Poland', dialCode: '48' },
  { iso2: 'PT', name: 'Portugal', dialCode: '351' },
  { iso2: 'PR', name: 'Puerto Rico', dialCode: '1' },
  { iso2: 'QA', name: 'Qatar', dialCode: '974' },
  { iso2: 'RE', name: 'Reunion', dialCode: '262' },
  { iso2: 'RO', name: 'Romania', dialCode: '40' },
  { iso2: 'RU', name: 'Russia', dialCode: '7' },
  { iso2: 'RW', name: 'Rwanda', dialCode: '250' },
  { iso2: 'KN', name: 'Saint Kitts and Nevis', dialCode: '1' },
  { iso2: 'LC', name: 'Saint Lucia', dialCode: '1' },
  { iso2: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: '1' },
  { iso2: 'WS', name: 'Samoa', dialCode: '685' },
  { iso2: 'SM', name: 'San Marino', dialCode: '378' },
  { iso2: 'ST', name: 'Sao Tome and Principe', dialCode: '239' },
  { iso2: 'SA', name: 'Saudi Arabia', dialCode: '966' },
  { iso2: 'SN', name: 'Senegal', dialCode: '221' },
  { iso2: 'RS', name: 'Serbia', dialCode: '381' },
  { iso2: 'SC', name: 'Seychelles', dialCode: '248' },
  { iso2: 'SL', name: 'Sierra Leone', dialCode: '232' },
  { iso2: 'SG', name: 'Singapore', dialCode: '65' },
  { iso2: 'SK', name: 'Slovakia', dialCode: '421' },
  { iso2: 'SI', name: 'Slovenia', dialCode: '386' },
  { iso2: 'SB', name: 'Solomon Islands', dialCode: '677' },
  { iso2: 'SO', name: 'Somalia', dialCode: '252' },
  { iso2: 'ZA', name: 'South Africa', dialCode: '27' },
  { iso2: 'KR', name: 'South Korea', dialCode: '82' },
  { iso2: 'SS', name: 'South Sudan', dialCode: '211' },
  { iso2: 'ES', name: 'Spain', dialCode: '34' },
  { iso2: 'LK', name: 'Sri Lanka', dialCode: '94' },
  { iso2: 'SD', name: 'Sudan', dialCode: '249' },
  { iso2: 'SR', name: 'Suriname', dialCode: '597' },
  { iso2: 'SE', name: 'Sweden', dialCode: '46' },
  { iso2: 'CH', name: 'Switzerland', dialCode: '41' },
  { iso2: 'SY', name: 'Syria', dialCode: '963' },
  { iso2: 'TW', name: 'Taiwan', dialCode: '886' },
  { iso2: 'TJ', name: 'Tajikistan', dialCode: '992' },
  { iso2: 'TZ', name: 'Tanzania', dialCode: '255' },
  { iso2: 'TH', name: 'Thailand', dialCode: '66' },
  { iso2: 'TL', name: 'Timor-Leste', dialCode: '670' },
  { iso2: 'TG', name: 'Togo', dialCode: '228' },
  { iso2: 'TO', name: 'Tonga', dialCode: '676' },
  { iso2: 'TT', name: 'Trinidad and Tobago', dialCode: '1' },
  { iso2: 'TN', name: 'Tunisia', dialCode: '216' },
  { iso2: 'TR', name: 'Turkey', dialCode: '90' },
  { iso2: 'TM', name: 'Turkmenistan', dialCode: '993' },
  { iso2: 'TC', name: 'Turks and Caicos Islands', dialCode: '1' },
  { iso2: 'UG', name: 'Uganda', dialCode: '256' },
  { iso2: 'UA', name: 'Ukraine', dialCode: '380' },
  { iso2: 'AE', name: 'United Arab Emirates', dialCode: '971' },
  { iso2: 'GB', name: 'United Kingdom', dialCode: '44' },
  { iso2: 'US', name: 'United States', dialCode: '1' },
  { iso2: 'UY', name: 'Uruguay', dialCode: '598' },
  { iso2: 'UZ', name: 'Uzbekistan', dialCode: '998' },
  { iso2: 'VU', name: 'Vanuatu', dialCode: '678' },
  { iso2: 'VE', name: 'Venezuela', dialCode: '58' },
  { iso2: 'VN', name: 'Vietnam', dialCode: '84' },
  { iso2: 'VG', name: 'Virgin Islands (British)', dialCode: '1' },
  { iso2: 'VI', name: 'Virgin Islands (U.S.)', dialCode: '1' },
  { iso2: 'YE', name: 'Yemen', dialCode: '967' },
  { iso2: 'ZM', name: 'Zambia', dialCode: '260' },
  { iso2: 'ZW', name: 'Zimbabwe', dialCode: '263' },
].sort((a, b) => a.name.localeCompare(b.name));

export const E164_PHONE_REGEX = /^\+[1-9]\d{1,14}$/;
